{
    "recruiting": "Werving",
    "courses": "Cursussen",
    "courses-page": {
        "title": "Cursussen",
        "create": "Cursus aanmaken",
        "edit": "Cursus bewerken",
        "empty": "Nog geen cursussen",
        "fields": {
            "title": "Titel",
            "description": "Beschrijving",
            "documents-count": "Documenten"
        },
        "headers": {
            "title": "Titel",
            "description": "Beschrijving",
            "documents": "Documenten",
            "actions": "Acties"
        },
        "dialog": {
            "title-label": "Titel",
            "description-label": "Beschrijving",
            "documents-label": "Documenten",
            "documents-placeholder": "Kies kennisbankdocumenten",
            "save": "Opslaan",
            "cancel": "Annuleren"
        },
        "messages": {
            "created": "Cursus aangemaakt",
            "updated": "Cursus bijgewerkt",
            "deleted": "Cursus verwijderd",
            "error": "Er is iets misgegaan"
        },
        "confirm-delete": "Deze cursus verwijderen? Dit kan niet ongedaan worden gemaakt."
    },
    "ai-study-chat": "AI-studiechat",
    "ai-study-chat-page": {
        "title": "AI-studiechat",
        "new-conversation": "Nieuw gesprek",
        "empty-sidebar": "Nog geen gesprekken",
        "empty-thread": "Kies een cursus of scenario om te beginnen met leren",
        "untitled": "Nieuwe chat",
        "input-placeholder": "Typ uw vraag…",
        "send": "Verzenden",
        "typing": "Assistent is aan het typen…",
        "sources": "Bronnen ({count})",
        "score": "relevantie",
        "retry": "Opnieuw proberen",
        "failed": "Verzenden mislukt",
        "sources-label": "Bronnen",
        "copy": "Kopiëren",
        "copied": "Gekopieerd",
        "search-placeholder": "Gesprekken zoeken",
        "search-empty": "Niets gevonden",
        "empty": {
            "heading": "Klaar om u te helpen leren",
            "subtitle": "Stel gerust vragen over het cursusmateriaal — ik zoek het antwoord op in de kennisbank en laat de bronnen zien."
        },
        "groups": {
            "today": "Vandaag",
            "yesterday": "Gisteren",
            "earlier": "Eerder"
        },
        "composer": {
            "context": "Context:",
            "hint": "Antwoorden zijn door AI gegenereerd op basis van uw materialen · Enter om te verzenden, Shift+Enter voor een nieuwe regel"
        },
        "suggestions-fallback": [
            {
                "title": "Materialen samenvatten",
                "subtitle": "Kernpunten"
            },
            {
                "title": "Studieplan opstellen",
                "subtitle": "Waar te beginnen"
            },
            {
                "title": "Overhoor mij",
                "subtitle": "Snelle check"
            },
            {
                "title": "Eenvoudig uitleggen",
                "subtitle": "Zonder jargon"
            }
        ],
        "suggestions-fallback-debrief": [
            { "title": "Bespreek deze sessie", "subtitle": "Belangrijkste inzichten" },
            { "title": "Wat deed ik goed?", "subtitle": "Mijn sterke punten" },
            { "title": "Waar ging het mis en waarom?", "subtitle": "Groeipunten" },
            { "title": "Wat moet ik verbeteren in de volgende sessie?", "subtitle": "Concrete stappen" }
        ],
        "suggestions-fallback-progress": [
            { "title": "Hoe ontwikkelen mijn resultaten zich?", "subtitle": "Over sessies heen" },
            { "title": "Mijn sterke en zwakke vaardigheden", "subtitle": "Uit sessieresultaten" },
            { "title": "Waar moet ik op focussen?", "subtitle": "Trainingsprioriteit" },
            { "title": "Vergelijk mijn eerste en laatste sessies", "subtitle": "Wat is verbeterd" }
        ],
        "quota": {
            "remaining": "{count} berichten over",
            "exhausted": "U heeft geen AI-chatberichten meer.",
            "unavailable": "AI-chat is niet beschikbaar in uw abonnement."
        },
        "new-dialog": {
            "title": "Nieuw gesprek",
            "subtitle": "Kies de bron waaruit de AI antwoorden geeft",
            "search": "Zoeken…",
            "search-empty": "Niets gevonden",
            "source-type": "Bron",
            "source-course": "Cursus",
            "source-scenario": "Scenario",
            "source-competency": "Competentie",
            "pick-course": "Kies een cursus",
            "pick-scenario": "Kies een scenario",
            "pick-competency": "Kies een competentie",
            "pick-target": "Alle sessies of een specifieke sessie",
            "all-games": "Alle sessies — mijn voortgang",
            "all-games-sub": "Resultaattrends voor deze competentie",
            "back": "Terug",
            "no-games": "Geen afgeronde sessies",
            "empty-competencies": "Nog geen afgeronde sessies",
            "empty-competencies-hint": "Rond een sessie af met een scenario met competentie — de AI-analyse verschijnt hier",
            "empty-courses": "Nog geen cursussen beschikbaar",
            "empty-scenarios": "Nog geen scenario's beschikbaar",
            "tag-game": "Sessie",
            "start": "Starten",
            "cancel": "Annuleren"
        },
        "stage": {
            "searching": "Je materiaal doorzoeken…",
            "reading": "Bronnen lezen…",
            "writing": "Antwoord schrijven…",
            "writing_sources": "{count} passages analyseren…",
            "summarizing_short": "Eerdere context ordenen",
            "searching_short": "Uw materialen doorzoeken",
            "reading_short": "Bronnen lezen",
            "writing_short": "Antwoord schrijven",
            "writing_sources_short": "{count} passages analyseren"
        },
        "errors": {
            "send": "Uw bericht kon niet worden verzonden. Probeer het opnieuw.",
            "quota": "Berichtquotum bereikt.",
            "rate_limit": "Te veel verzoeken. Wacht een minuut en probeer het opnieuw.",
            "provider_unsupported": "De kennisbankchat is niet beschikbaar met de huidige AI-provider van uw organisatie.",
            "generic": "Er is iets misgegaan."
        }
    },
    "base_title": "The Reflection",
    "base_title_ru": "SkillsTrainer",
    "404_title": "Pagina niet gevonden ⚠️",
    "404_description": "We konden de pagina die u zoekt niet vinden.",
    "404_home": "Terug naar home",
    "401_title": "U bent niet geautoriseerd! 🔐",
    "401_description": "U hebt geen toestemming om deze pagina te openen. Ga naar de homepagina.",
    "401_home": "Terug naar home",
    "changes_saved": "Wijzigingen opgeslagen",
    "coming_soon": "Binnenkort beschikbaar",
    " ": " ",
    "select_date_and_time": "Selecteer datum en tijd",
    "select_date": "Selecteer datum",
    "chat": "Chat",
    "menu": "Menu",
    "games": "Sessies",
    "tours": "Rondes",
    "library": "Bibliotheek",
    "library-video": "Video",
    "library-scorm": "Cursussen",
    "library-documents": "Documenten",
    "scenarios": "Scenario's",
    "competencies": "Competenties",
    "competencies-list": "Lijst",
    "skills": "Vaardigheden",
    "home": "Home",
    "home_player": "Deelnemer",
    "player": "Deelnemer",
    "home_expert": "Expert",
    "reports-analytics-tours": "Rondes",
    "reports": "Rapporten",
    "ranking": "Ranglijst",
    "analytics": "Analytics",
    "support": "Ondersteuning",
    "users": "Gebruikers",
    "participants": "Deelnemers",
    "departments": "Afdelingen",
    "positions": "Functies",
    "user-custom-fields": "Aangepaste velden",
    "administration": "Beheer",
    "ai-assistants": "AI-assistenten",
    "ai-profiles": "AI-profielen",
    "ai-connectors": "AI-connectors",
    "Audit logs": "Auditlogboeken",
    "organizations": "Organisaties",
    "loading": "Laden...",
    "retry": "Opnieuw proberen",
    "previous": "Vorige",
    "next": "Volgende",
    "save": "Opslaan",
    "copy": "Kopiëren",
    "copy_failed": "Automatisch kopiëren is niet gelukt. Selecteer de tekst in het veld en kopieer deze handmatig (Ctrl+C of ⌘C).",
    "confirm": "Bevestigen",
    "suggest": "Voorstellen",
    "generate": "Genereren",
    "cancel": "Annuleren",
    "close": "Sluiten",
    "search": "Zoeken...",
    "accept": "Accepteren",
    "propose": "Voorstellen",
    "decline": "Afwijzen",
    "send_request": "Verzoek versturen",
    "assign": "Toewijzen",
    "actions": " ",
    "evaluators": {
        "ai": "AI",
        "expert": "Expert",
        "player": "Deelnemer",
        "manager": "Manager",
        "head": "Leidinggevende"
    },
    "statistics": {
        "date_from": "Van",
        "date_to": "Tot",
        "competence": "Competentie",
        "evaluator": "Beoordelaar",
        "last_games_effectiveness": {
            "effectiveness": "Effectiviteit",
            "title": "Effectiviteit per sessie"
        },
        "skill_trend": {
            "average_score": "Gemiddelde score",
            "game": "Sessie",
            "score": "Score",
            "title": "Gemiddelde score per competentie"
        },
        "player_competence_radar": {
            "title": "Competentiestatistieken",
            "top": "Top 10",
            "players_in_company": "Deelnemers in het bedrijf",
            "by_games": "Analyse per sessie",
            "subtitle": "Algemene statistieken voor jou en je bedrijf",
            "filter": "Filter",
            "you": "Jij",
            "company": "Bedrijf",
            "average_score": "gemiddelde score",
            "skills_counted": "op basis van {counted} van de {total} vaardigheden"
        }
    },
    "participant": {
        "upcoming_games": "Aankomende sessies",
        "for_rank_games": "Te beoordelen"
    },
    "roles": {
        "player": "Deelnemer",
        "admin": "SuperAdmin (systeem)",
        "scoped_admin": "Hoofdbeheerder",
        "observer": "Toeschouwer",
        "captain": "Kapitein",
        "expert": "Expert",
        "lead_expert": "Hoofdexpert",
        "manager": "Manager",
        "support": "Ondersteuning",
        "early_access": "Vroege toegang",
        "head": "Leidinggevende",
        "candidate": "Kandidaat"
    },
    "user-status": {
        "active": "Actief",
        "inactive": "Inactief",
        "pending": "In behandeling"
    },
    "pagination": {
        "showing": "weergegeven",
        "to": "tot",
        "of": "van",
        "entries": "items"
    },
    "validator": {
        "required": "Dit veld is verplicht",
        "library": "Bestandsgrootte moet minder dan 500MB zijn",
        "email": "Het e-mailveld moet een geldig e-mailadres zijn",
        "password": "Veld moet minstens één hoofdletter, kleine letter, speciaal teken en cijfer bevatten met min. 8 tekens",
        "confirm": "Het veld Wachtwoord bevestigen komt niet overeen",
        "at_least": "Het veld moet minstens",
        "items": "items",
        "number": "Dit veld moet een geheel getal zijn",
        "is_odd": "Dit veld moet even zijn",
        "number_between": "Voer een getal in tussen",
        "number_and": "en",
        "date_range_required": "Bereik vereist",
        "invalid_date_range": "Ongeldig bereik",
        "invalid_date_format": "Ongeldig datumformaat",
        "start_date_after_end_date": "Datum van moet voor datum tot liggen",
        "max_180_days": "Maximaal 180 dagen"
    },
    "user": {
        "menu": {
            "settings": "Instellingen",
            "statistics": "Statistieken",
            "logout": "Uitloggen"
        }
    },
    "theme": {
        "system": "Systeem",
        "light": "Licht",
        "dark": "Donker"
    },
    "error": {
        "default": "Sorry, er is een fout opgetreden. Onze specialisten zijn al op de hoogte en lossen dit zo snel mogelijk op.",
        "unauthorized": "Uw sessie is verlopen.",
        "contact-support": "Sorry, er is een fout opgetreden. Neem contact op met de technische ondersteuning",
        "forbidden": "Toegang geweigerd"
    },
    "confirmation": {
        "sure": "Weet u zeker dat u het item wilt verwijderen?",
        "sure_return_to_time_scheduling": "Weet u zeker dat u de sessie wilt terugzetten naar de fase van starttijdcoördinatie?",
        "sure_restore": "Weet u zeker dat u het item wilt herstellen?",
        "sure_mark_failed": "Het spel als mislukt markeren en alle evaluaties en deelnemersprotocollen permanent verwijderen?",
        "success": "Succes!",
        "deleted": "Verwijderd",
        "failed_marked": "Spel gemarkeerd als mislukt",
        "restored": "Hersteld",
        "cancel": "Geannuleerd",
        "yes": "Ja",
        "no": "Nee"
    },
    "dashboards": {
        "player": {
            "summary": {
                "welcome": "Welkom terug",
                "progress": "Uw algemene voortgang",
                "stats": {
                    "minutes": "Minuten in sessie",
                    "effectiveness": "Effectiviteit",
                    "completed_games_count": "Succesvolle sessies",
                    "total_games_count": "Totaal aantal sessies"
                }
            },
            "cards": {
                "players_rating": {
                    "title": "Bedrijfsranglijst",
                    "player": "Deelnemer",
                    "effectiveness": "Effectiviteit"
                }
            }
        },
        "head": {
            "my_stats": "Mijn statistieken",
            "subordinates": "Mijn medewerkers",
            "subordinate_stats": "Statistieken medewerker",
            "select_subordinate": "Selecteer een medewerker om statistieken te bekijken",
            "no_subordinates": "Geen medewerkers toegewezen"
        }
    },
    "chat-page": {
        "last_game": "Laatste sessie",
        "chats": "Chats",
        "no-chats": "Geen chats gevonden",
        "contacts": "Contacten",
        "choose": "Kies contact",
        "send": "Verzenden",
        "type": "Typ uw bericht...",
        "no-contacts": "Geen contacten gevonden",
        "search": "Zoeken...",
        "start_conversation": "Gesprek starten",
        "start_connecting": " Begin met verbinden met mensen door links een contact te selecteren"
    },
    "scenarios-page": {
        "title": "Titel",
        "export-docx": "Export .docx",
        "copy_title": "Scenario kopiëren",
        "generate_ai_title": "AI-scenario genereren",
        "organization": "Bedrijf",
        "competence": "Competentie",
        "actions": " ",
        "add": "Scenario toevoegen",
        "ai-generate": "AI genereren",
        "copy": "Scenario kopiëren",
        "add_popup": "Scenario toevoegen",
        "delete": "Scenario verwijderen",
        "edit": "Scenario bewerken",
        "edit_popup": "Scenario bewerken",
        "industries": [
            "FMCG/Retail",
            "Farmaceutica",
            "Banken en Fintech",
            "Hotels en Toerisme",
            "IT-bedrijven/SaaS",
            "Horeca/Horeca",
            "E-commerce/Marktplaatsen",
            "Productie/Industrie 4.0",
            "Logistiek en T&L",
            "Telecom",
            "Onderwijs/EdTech",
            "Chemische industrie",
            "Supply chain management software",
            "Overheid/Non-profitorganisaties"
        ],
        "case_types": [
            "Leiderschap en People-Management",
            "Werving en Personeelsbeoordeling",
            "Verkoop en Klantenservice",
            "Onderhandelingen en Beïnvloeding",
            "Conflicthantering",
            "Strategie en Uitvoering"
        ],
        "cases": [
            [
                "SMART/OKR Doelstellingen",
                "Ontwikkelingsgerichte feedback geven (SBI/COIN)",
                "Delegatie",
                "GROW-coaching",
                "Prestatiebeoordeling",
                "Mentorschap"
            ],
            [
                "Competentiegericht interview (CBI)",
                "Assessment/Assessment Center",
                "Onboarding-sessie"
            ],
            [
                "Klassieke verkoop van product/dienst",
                "Omgaan met bezwaren",
                "Upsell/Cross-sell",
                "Klachtenafhandeling",
                "Omnichannel verkoop"
            ],
            [
                "Interne onderhandelingen over budget/middelen",
                "Contract met klant/leverancier",
                "Crisisonderhandelingen"
            ],
            [
                "Interpersoonlijk teamconflict",
                "Leidinggevende-ondergeschikte",
                "Waarden/Ethiek-conflict"
            ],
            [
                "Portfolio-prioritering van projecten",
                "Verandermanagement",
                "Risicoanalyse"
            ]
        ],
        "formats": [
            "1-1",
            "Teams"
        ],
        "labels": {
            "industry": "Industrie",
            "case_type": "Casustype",
            "case": "Casus",
            "format": "Formaat",
            "duration": "Duur (minuten)",
            "game_vs_ai": "Sessie vs AI",
            "level": "Niveau",
            "competence": "Competentie",
            "description": "Scenariobeschrijving",
            "description_hint": "Beschrijf optioneel het scenario dat u wilt genereren (max 4000 tekens)"
        },
        "generating_in_progress": "Scenario wordt gegenereerd, even geduld..."
    },
    "analytics-page": {
        "tours-page": {
            "tour": "Ronde",
            "full_name": "Deelnemer",
            "games_count": "Sessies",
            "team": "Team",
            "export": "Exporteren",
            "effectiveness": "Effectiviteit"
        }
    },
    "report-filters": {
        "department": "Afdeling",
        "position": "Functie",
        "employee": "Medewerker",
        "scenario": "Scenario",
        "competence": "Competentie",
        "period": "Periode",
        "reset": "Resetten",
        "only-period-competence": "Alleen de filters voor periode en competentie zijn van toepassing"
    },
    "competencies-page": {
        "title": "Titel",
        "export-docx": "Export .docx",
        "skills": "Vaardigheden",
        "text": "Tekst",
        "display_order": "Sorteren",
        "ai-assistant": "AI-assistent",
        "language": "Taal",
        "department": "Afdeling",
        "evaluation-target": "Wie beoordelen we?",
        "evaluation-both": "Beide deelnemers",
        "evaluation-team-a": "Alleen team A",
        "evaluation-both-tooltip": "Beide deelnemers worden beoordeeld - geschikt voor onderhandelingsscenario's",
        "evaluation-team-a-tooltip": "Alleen de leider wordt beoordeeld - feedbackformaat",
        "actions": " ",
        "add": "Competentie toevoegen",
        "add_popup": "Competentie toevoegen",
        "delete": "Competentie verwijderen",
        "edit": "Competentie bewerken",
        "edit_popup": "Competentie bewerken"
    },
    "faq-page": {
        "title": "Vragen",
        "question": "Vraag",
        "text": "Antwoord",
        "is_shared": "Beschikbaar voor alle bedrijven",
        "actions": " ",
        "visibility": "Zichtbaarheid",
        "visible_to_all": "Zichtbaar voor alle gebruikers",
        "visible_to_managers": "Alleen zichtbaar voor managers",
        "add": "Vraag toevoegen",
        "add_popup": "Vraag toevoegen",
        "delete": "Vraag verwijderen",
        "edit": "Vraag bewerken",
        "edit_popup": "Vraag bewerken"
    },
    "ai-connectors-page": {
        "title": "AI-connectors",
        "is_shared": "Beschikbaar voor alle organisaties",
        "actions": " ",
        "add": "Connector toevoegen",
        "add_popup": "Connector toevoegen",
        "delete": "Connector verwijderen",
        "edit": "Connector bewerken",
        "edit_popup": "Connector bewerken",
        "label": "Label",
        "provider": "Provider",
        "service": "Service",
        "organization": "Organisatie",
        "status": "Status",
        "region": "Regio",
        "endpoint": "Endpoint",
        "secret": "Wachtwoord/Sleutel",
        "maxConcurrency": "Max gelijktijdigheid",
        "timeoutSec": "Timeout",
        "sortOrder": "Sorteervolgorde",
        "config": "Configuratie",
        "modelPrimary": "Primair model",
        "modelLight": "Light-model",
        "modelLightHint": "Leeg: Light-aanroepen gebruiken het primaire model",
        "folderId": "Folder-ID",
        "models": "Modellen",
        "is_default": "Standaard",
        "notes": "Notities"
    },
    "skills-page": {
        "title": "Titel",
        "display_order": "Sorteren",
        "competence": "Competentie",
        "text": "Indicatoren",
        "actions": " ",
        "add": "Vaardigheid toevoegen",
        "add_popup": "Vaardigheid toevoegen",
        "delete": "Vaardigheid verwijderen",
        "edit": "Vaardigheid bewerken",
        "edit_popup": "Vaardigheid bewerken"
    },
    "departments-page": {
        "title": "Titel",
        "actions": " ",
        "add": "Afdeling toevoegen",
        "add_popup": "Afdeling toevoegen",
        "delete": "Afdeling verwijderen",
        "edit": "Afdeling bewerken",
        "edit_popup": "Afdeling bewerken"
    },
    "tours-page": {
        "title": "Titel",
        "actions": " ",
        "add": "Ronde toevoegen",
        "add_popup": "Ronde toevoegen",
        "delete": "Ronde verwijderen",
        "edit": "Ronde bewerken",
        "edit_popup": "Ronde bewerken"
    },
    "library-page": {
        "title": "Titel",
        "text": "Beschrijving",
        "video": "Video",
        "courses": "Cursussen",
        "video_link_copy": "Link kopiëren",
        "video_in_process": "Video wordt verwerkt...",
        "is_public": "Is openbaar",
        "actions": " ",
        "add": "Video toevoegen",
        "add_popup": "Video toevoegen",
        "delete": "Video verwijderen",
        "edit": "Video bewerken",
        "edit_popup": "Video bewerken"
    },
    "library-documents-page": {
        "title": "Titel",
        "actions": " ",
        "add": "Document toevoegen",
        "add_popup": "Document toevoegen",
        "delete": "Document verwijderen",
        "edit": "Document bewerken",
        "edit_popup": "Document bewerken",
        "file": "Bestand"
    },
    "scorm-page": {
        "title": "Titel",
        "actions": " ",
        "add": "Cursus toevoegen",
        "loading": "Cursus wordt geladen...",
        "add_popup": "Cursus toevoegen",
        "delete": "Cursus verwijderen",
        "edit": "Cursus bewerken",
        "edit_popup": "Cursus bewerken",
        "zip_file": "ZIP-bestand"
    },
    "ai-assistants-page": {
        "external_id": "ID",
        "description": "Beschrijving",
        "actions": " ",
        "add": "AI-assistent toevoegen",
        "add_popup": "AI-assistent toevoegen",
        "delete": "AI-assistent verwijderen",
        "edit": "AI-assistent bewerken",
        "edit_popup": "AI-assistent bewerken"
    },
    "ai-prompts-page": {
        "name": "Naam",
        "content": "Inhoud",
        "actions": " ",
        "add": "AI-prompt toevoegen",
        "add_popup": "AI-prompt toevoegen",
        "delete": "AI-prompt verwijderen",
        "edit": "AI-prompt bewerken",
        "edit_popup": "AI-prompt bewerken",
        "key": "Slotsleutel",
        "model": "Model",
        "updated_at": "Bijgewerkt",
        "custom": "Aangepast",
        "description": "Beschrijving",
        "temperature": "Temperature",
        "top_p": "Top P",
        "reasoning_effort": "Reasoning-inspanning",
        "reasoning_effort_default": "Standaard",
        "required_placeholders": "Verplichte placeholders (moeten in de inhoud voorkomen)",
        "versions": "Versiegeschiedenis",
        "no_versions": "Nog geen versies",
        "restore": "Herstellen",
        "restore_confirm": "Deze versie herstellen? De inhoud wordt de huidige versie.",
        "restored": "Versie hersteld",
        "current_version": "Huidig",
        "author": "Auteur",
        "error": "Er is iets misgegaan.",
        "tab_system": "Systeem",
        "tab_custom": "Aangepast",
        "system_hint": "Systeemprompts worden gebruikt door de platformcode. Ze kunnen niet worden verwijderd, maar de inhoud kan wel worden bewerkt.",
        "custom_hint": "Aangepaste prompts worden aan competenties en AI-profielen gekoppeld als override van de beoordelingsprompt.",
        "model_from_code": "bepaald door code",
        "model_from_code_hint": "Het model wordt gekozen door de code die de prompt gebruikt; het wordt niet in de prompt zelf opgeslagen.",
        "used_by": "Gebruikt door",
        "used_by_value": "Competenties: {competencies}, AI-profielen: {profiles}",
        "not_used": "Niet gebruikt",
        "delete_blocked_hint": "Kan niet worden verwijderd: de prompt wordt gebruikt als override. {usage}",
        "slot_description": {
            "game_eval_negotiation": "AI-evaluatie van PvP-sessies: onderhandeling",
            "game_eval_feedback": "AI-evaluatie van PvP-sessies: feedback",
            "game_eval_vs_ai": "AI-evaluatie van rollenspellen met AI (wanneer het AI-profiel geen override heeft)",
            "protocol_evaluation": "Het scenarioprotocol invullen op basis van het transcript van een rollenspel met AI",
            "voice_agent": "Systeemprompt voor de virtuele AI-gesprekspartner",
            "scenario_generation": "Scenariogeneratie op basis van een beschrijving",
            "scenario_card_update": "Bijwerken van de scenariokaart op basis van een AI-beschrijving",
            "scenario_optimize": "Optimaliseren van de AI-beschrijving van een scenario",
            "skill_report_analysis": "Vaardigheidsrapport: analysestap",
            "skill_report_recommendations": "Vaardigheidsrapport: aanbevelingsstap"
        }
    },
    "ai-profiles-page": {
        "name": "Naam",
        "settings": "Instellingen",
        "temperature": "Creativiteit",
        "demeanor": "Houding",
        "behavior": "Gedrag, instructies",
        "background": "Biografie",
        "style": "Stijl",
        "instructions": "Instructies",
        "supportive_phrases": "Steunende zinnen",
        "ai_assistant": "AI-assistent",
        "ai_starts_first": "AI begint eerst",
        "first_phrase": "Eerste zin",
        "closing_phrases": "Afsluitende zinnen",
        "voice": "Stem",
        "expert_mode": "Expertmodus",
        "custom_demeanor_hint": "Huidig aangepast gedrag",
        "is_shared": "Beschikbaar voor alle organisaties",
        "voice_options": {
            "male": "Man",
            "female": "Vrouw"
        },
        "demeanor_options": {
            "friendly": {
                "title": "Vriendelijk",
                "description": "Gemakkelijk benaderbaar en prettig"
            },
            "critical": {
                "title": "Kritisch",
                "description": "Wijst vaak op tekortkomingen en verbeterpunten"
            },
            "empathetic": {
                "title": "Empathisch",
                "description": "Zeer gevoelig voor gevoelens en emoties van anderen"
            },
            "enthusiastic": {
                "title": "Enthousiast",
                "description": "Toont grote opwinding en enthousiasme"
            },
            "analytical": {
                "title": "Analytisch",
                "description": "Richt zich op logica en gedetailleerde probleemoplossing"
            },
            "curious": {
                "title": "Nieuwsgierig",
                "description": "Leergierig en stelt vragen"
            },
            "assertive": {
                "title": "Assertief",
                "description": "Zelfverzekerd en standvastig"
            },
            "blunt": {
                "title": "Bot",
                "description": "Direct en to the point"
            },
            "skeptical": {
                "title": "Sceptisch",
                "description": "Achterdochtig tegenover nieuwe oplossingen en ideeën"
            },
            "neutral": {
                "title": "Neutraal",
                "description": "Evenwichtig en objectief in communicatiestijl"
            },
            "casual": {
                "title": "Informeel",
                "description": "Ontspannen en gesprekstoon"
            }
        },
        "placeholders": {
            "name": "Bijvoorbeeld: Sergei (beleefd en vriendelijk)",
            "demeanor": "Bijvoorbeeld: Vriendelijk, beleefd en sociaal...",
            "background": "Bijvoorbeeld: Twee keer ontslagen...",
            "behavior": "Bijvoorbeeld: Onderbreekt niet, luistert actief...",
            "first_phrase": "Bijvoorbeeld: Goedendag! Hoe is uw humeur?",
            "closing_phrases": "Bijvoorbeeld: We hebben bijna geen tijd meer, dus stel ik voor dat we onze vergadering snel samenvatten."
        },
        "actions": " ",
        "add": "AI-profiel toevoegen",
        "add_popup": "AI-profiel toevoegen",
        "subtitle": "Hoe de gesprekspartner eruitziet en klinkt in de sessie",
        "preview": {
            "title": "Voorbeeld",
            "unnamed": "Naamloos",
            "voice": "stem {name}",
            "defaultVoice": "standaardstem",
            "defaultPhoto": "Standaardfoto",
            "listen": "Stem beluisteren",
            "defaultVoiceNotice": "De stem wordt aan het begin van de sessie gekozen — vooraf beluisteren kan niet",
            "photoPlaceholder": "Hier verschijnt de foto"
        },
        "delete": "AI-profiel verwijderen",
        "edit": "AI-profiel bewerken",
        "edit_popup": "AI-profiel bewerken",
        "avatar_hint": "avatarafbeelding",
        "avatar_save_first": "Sla eerst het profiel op om avatars te kunnen uploaden",
        "avatar_requirements": "Max. 1 MB • Aanbevolen: 1536×1024 • Beeldverhouding: 3:2",
        "max_characters": "Maximaal {max} tekens"
    },
    "games-page": {
        "game-with-ai": "Rollenspel met AI",
        "organization": "Organisatie",
        "status": "Status",
        "failure_reasons": {
            "protocol_not_agreed": "Deelnemers hebben het protocol niet goedgekeurd",
            "protocol_approval_expired": "Goedkeuringstijd van het protocol is verstreken",
            "annulled": "De sessie is geannuleerd door een beheerder",
            "expired": "De sessietijd is verstreken",
            "assignment_changed": "De cursustoewijzing in het leerplatform is gewijzigd"
        },
        "restore": "Herstellen",
        "play": "Spelen",
        "meetings_unavailable": "Videosessies tussen deelnemers zijn tijdelijk niet beschikbaar. Probeer het later opnieuw.",
        "import": "Importeren",
        "scenario": "Scenario",
        "tour": "Ronde",
        "game_types": {
            "classic": "Klassieke modus",
            "vs_ai": "Rollenspel met AI",
            "uploaded_recording": "Opname"
        },
        "upload_recording": {
            "file": "Opnamebestand",
            "file_hint": "Video of audio, tot 1 GB",
            "uploaded": "Bestand geüpload",
            "file_too_large": "Bestand groter dan 1 GB",
            "upload_error": "Uploaden van het bestand mislukt",
            "player": "Deelnemer",
            "rate_both": "Beide deelnemers beoordelen",
            "second_player": "Tweede deelnemer",
            "open_session": "Sessie openen"
        },
        "game_targets": {
            "user": "Deelnemer",
            "position": "Functie",
            "department": "Afdeling"
        },
        "number": "Nummer",
        "start_up_to": "Starten tot",
        "start_time": "Starttijd",
        "teamA": "Team A",
        "teamB": "Team B",
        "others": "Deelnemers",
        "actions": " ",
        "edit_results": "Resultaten wijzigen",
        "add": "Sessie toevoegen",
        "add_popup": "Sessie toevoegen",
        "delete": "Sessie verwijderen",
        "edit": "Sessie bewerken",
        "edit_popup": "Sessie bewerken",
        "time_scheduling": "Starttijd plannen",
        "return_to_time_scheduling": "Terug naar starttijd plannen",
        "preparation": "Voorbereiding op de sessie",
        "view_scenario": "Scenario bekijken",
        "protocol": "Protocolgoedkeuring",
        "not_agreed": "Niet overeengekomen",
        "expert-accept": "Accepteren en doorgaan naar evaluatie",
        "expert-decline": "Afwijzen",
        "hide_ai_results": "AI-resultaten verbergen",
        "show_ai_results": "AI-resultaten tonen",
        "mark_failed": "Als mislukt markeren",
        "popup": {
            "start_up_to": "Starten tot",
            "target": "Aan wie moet de sessie worden toegewezen?",
            "custom_field_value": "Waarde van “{field}”",
            "target_preview_count": "Aan te maken sessies: {count}",
            "target_preview_empty": "Geen enkele speler valt binnen deze selectie — er wordt geen sessie aangemaakt",
            "target_preview_limit_exceeded": "Dat is meer dan één toewijzing kan aanmaken (maximaal {limit}). Verklein de selectie, het aantal cases of het aantal kopieën",
            "copies_per_player": "Kopieën van elke case per speler",
            "position": "Functie",
            "department": "Afdeling",
            "scenario": "Scenario",
            "optional": "Optioneel, kan worden weggelaten",
            "protocol_time": "Tijd voor protocol",
            "protocol_time_hint": "Getal tussen 1 en 1440",
            "preparation_time": "Voorbereidingstijd",
            "preparation_time_hint": "In minuten",
            "game_duration": "Sessieduur",
            "game_duration_hint": "Getal tussen 1 en 60",
            "is_team": "Scenario voor teams",
            "is_camera_required": "Deelnemerscamera's vereist",
            "is_self_rated": "Deelnemers kunnen zichzelf beoordelen",
            "is_each_other_rated": "Deelnemers kunnen elkaar beoordelen",
            "is_expert_rated": "Expertbeoordeling beschikbaar",
            "is_ai_rated": "AI-beoordeling beschikbaar",
            "show_results": "Resultaten tonen",
            "automatically": "automatisch",
            "manually": "handmatig",
            "is_public_hint": "Elke toeschouwer kan deelnemen",
            "is_public": "Openbare sessie",
            "team_a": "Team A",
            "team_b": "Team B",
            "player_a": "Deelnemer A",
            "player_b": "Deelnemer B",
            "expert": "Expert",
            "observers": "Toeschouwers",
            "tour": "Ronde",
            "search": "Zoeken...",
            "choose_players": "Kies deelnemers",
            "choose_expert": "Kies expert",
            "choose_observers": "Kies toeschouwers",
            "choose_scenario": "Kies scenario",
            "choose_tour": "Kies ronde",
            "expert_empty": "Indien niet gekozen, kan de kapitein kiezen",
            "captain": "Kapitein",
            "": "",
            "protocol": {
                "title": "Protocolgoedkeuring",
                "target": "Doel",
                "await_approval": "Wacht op goedkeuring van tegenstander",
                "await_proposal": "Wacht op voorstel van tegenstander",
                "questions": "Vragen voor uw team",
                "questions_a": "Vragen voor team A",
                "questions_b": "Vragen voor team B",
                "not_agreed": "Geen akkoord",
                "not_agreed_confirm": "De sessie wordt niet succesvol beëindigd en de resultaten worden niet meegeteld. Deze actie is onomkeerbaar.",
                "not_agreed_done": "De sessie is niet succesvol geëindigd."
            },
            "start_time": {
                "title": "Starttijd",
                "must_start_by": "Moet starten vóór"
            },
            "edit_results": {
                "title": "Resultaten wijzigen"
            },
            "preparation": {
                "title": "Voorbereiding op de sessie",
                "description": "Beschrijving",
                "description_team": "Teambeschrijving",
                "notes": "Persoonlijke notities"
            },
            "import": {
                "download_example": "Voorbeeld downloaden",
                "title": "Import van sessies",
                "button": "Import starten",
                "label": "Excel-bestand"
            },
            "create_multi_scenario_games_immediately": "Alle sessies worden onmiddellijk aangemaakt",
            "create_multi_scenario_games_sequentially": "Sessies worden achtereenvolgens aangemaakt (na succesvolle voltooiing van elk)"
        }
    },
    "ai-game": {
        "title": "Rollenspel met AI",
        "recording": "Opname",
        "ai": "AI",
        "you": "U",
        "ai_ready": "Klaar",
        "camera_off": "Camera is uit",
        "stop_game": "Sessie stoppen",
        "start_game": "Sessie starten",
        "mic_permission": "Geef in de instellingen microfoonrechten om de sessie te starten",
        "permissions_granted": "Machtigingen succesvol verleend!",
        "close": "Sluiten",
        "microphone_required": "Please grant microphone permissions to start the session",
        "mic_required": "Schakel de microfoon in om de sessie te starten",
        "mic_not_detected": "Nog geen geluid gedetecteerd — probeer te spreken of controleer uw microfoon",
        "permissions_needed": "Microfoontoegang is vereist. Camera is optioneel",
        "agent": {
            "initializing": "Initializing...",
            "listening": "Listening",
            "thinking": "Thinking...",
            "speaking": "Speaking",
            "waiting": "Waiting for agent..."
        },
        "waiting_for_start": "Start the session to begin conversation",
        "grant_microphone": "Grant Microphone Access",
        "game_not_found": "Session Not Found",
        "game_not_found_desc": "Session with ID {id} could not be located.",
        "confirm": {
            "start_question": "Weet u het zeker? De sessie kan niet worden gepauzeerd",
            "start_title": "Sessie gestart",
            "start_success": "De sessie is succesvol gestart",
            "start_cancel_title": "Sessie niet gestart",
            "start_cancel_msg": "Het starten van de sessie is geannuleerd",
            "end_question": "Weet u het zeker? De sessie wordt beëindigd",
            "end_title": "Sessie beëindigd",
            "end_success": "De sessie is succesvol beëindigd",
            "end_cancel_title": "Sessie niet beëindigd",
            "end_cancel_msg": "Het beëindigen van de sessie is geannuleerd"
        },
        "voice": {
            "disconnected": "Verbinding verbroken",
            "connecting": "Verbinden...",
            "connected": "Verbonden met server",
            "connection_error": "Verbinding met stemagent mislukt",
            "game_already_finished": "Dit spel is al beëindigd",
            "connection_timeout": "Connection to voice server timed out. This may be caused by a firewall or network restrictions. Check your network settings and try again.",
            "no_rooms_available": "Er zijn momenteel geen kamers beschikbaar. Probeer het later opnieuw.",
            "preparing_recording": "Opname wordt voorbereid, opnieuw proberen over {seconds}s…",
            "recording_service_overloaded": "De opnameservice is overbelast. Probeer het over enkele minuten opnieuw.",
            "session_quota_exhausted": "Het sessiepakket van uw organisatie is opgebruikt. Neem contact op met uw manager.",
            "connection_blocked": "Uw netwerk blokkeerde het opzetten van de AI-verbinding. Sta HTTPS (443) toe naar de vereiste domeinen en probeer het opnieuw.",
            "connection_blocked_signaling": "De firewall of proxy van uw netwerk blokkeert de verbinding met de spraakserver. Probeer verbinding te maken via een ander netwerk of mobiele hotspot.",
            "reconnecting": "Reconnecting...",
            "disconnect_dialog_title": "Connection Lost",
            "disconnect_dialog_message": "The connection was interrupted. Would you like to reconnect or finish the session?",
            "disconnect_retry": "Reconnect",
            "disconnect_finish": "Finish Session",
            "agent_join_timeout": "The AI agent did not connect in time. Please try again.",
            "stop_failed": "Failed to stop the session",
            "mic_enable_failed": "Microphone could not be enabled. You can try toggling it manually.",
            "mic_toggle_failed": "Failed to toggle microphone",
            "camera_toggle_failed": "Failed to toggle camera",
            "duplicate_tab_title": "Session Open in Another Tab",
            "duplicate_tab_message": "This session is already active in another browser tab. Close the other tab and reopen this page if you want to continue here.",
            "duplicate_tab_back": "Go Back",
            "duplicate_tab_disconnect_title": "Opened in Another Tab",
            "duplicate_tab_disconnect_message": "This tab was disconnected because the session is already active in another tab. Return to the session page from here."
        },
        "permissions_denied_safari": "Toegang tot camera of microfoon is geweigerd. Ga naar Safari-instellingen > Websites > Camera/Microfoon en sta toegang toe voor deze site.",
        "supported": "Browser ondersteund"
    },
    "positions-page": {
        "title": "Titel",
        "actions": " ",
        "add": "Functie toevoegen",
        "add_popup": "Functie toevoegen",
        "delete": "Functie verwijderen",
        "edit": "Functie bewerken",
        "edit_popup": "Functie bewerken"
    },
    "user-custom-fields-page": {
        "title": "Titel",
        "type": "Type",
        "options_count": "Waarden",
        "actions": " ",
        "add": "Veld toevoegen",
        "add_popup": "Veld toevoegen",
        "delete": "Veld verwijderen",
        "delete_confirm": "Veld verwijderen? De bij gebruikers opgeslagen waarden worden niet meer getoond.",
        "edit": "Veld bewerken",
        "edit_popup": "Veld bewerken",
        "empty": "Nog geen aangepaste velden",
        "error": "Kan het veld niet opslaan",
        "type_text": "Tekst",
        "type_select": "Keuzelijst",
        "type_locked_hint": "Het type kan na het aanmaken van het veld niet meer worden gewijzigd",
        "options": "Waarden",
        "options_hint": "De volgorde van de waarden hier is de volgorde in de keuzelijst",
        "options_required": "Voeg ten minste één waarde toe",
        "option_title": "Waarde",
        "option_add": "Waarde toevoegen",
        "option_delete": "Waarde verwijderen",
        "option_delete_confirm": "Waarde verwijderen? Bij gebruikers die deze hadden geselecteerd, wordt de waarde gewist.",
        "option_move_up": "Omhoog verplaatsen",
        "option_move_down": "Omlaag verplaatsen"
    },
    "organizations-page": {
        "name": "Naam",
        "host": "Host",
        "duel_limit": "Duellimiet",
        "max_users": "Max. gebruikers",
        "max_users_hint": "0 = onbeperkt",
        "max_vs_ai_games_per_scenario": "Max. AI-games per speler per scenario",
        "max_vs_ai_games_per_scenario_hint": "Leeg = geen limiet. Geldt voor het zelf aanmaken van games door spelers",
        "employee_report_daily_limit": "Rapportlimiet voor medewerkers per dag",
        "employee_report_daily_limit_hint": "Leeg = limiet voor het hele platform. Geldt voor managers en leidinggevenden",
        "employee_report_hourly_limit": "Rapportlimiet voor medewerkers per uur",
        "employee_report_hourly_limit_hint": "Leeg = limiet voor het hele platform. Geldt voor managers en leidinggevenden",
        "registration": "Registratie open",
        "timezone": "Tijdzone",
        "locale": "Locale",
        "users_count": "Gebruikers",
        "actions": " ",
        "add": "Organisatie toevoegen",
        "add_popup": "Organisatie toevoegen",
        "delete": "Organisatie verwijderen",
        "edit": "Organisatie bewerken",
        "edit_popup": "Organisatie bewerken",
        "available_languages": "Beschikbare talen",
        "show_game_numbers_for_player": "Sessienummers tonen voor deelnemer",
        "allow_players_choose_expert": "Deelnemers toestaan expert te kiezen",
        "send_message": "Bericht naar managers sturen",
        "message": "Bericht",
        "send": "Verzenden",
        "clear_message": "Bericht wissen",
        "current_message": "Huidig bericht",
        "two_factor_method": "Tweefactorauthenticatie",
        "two_factor_disabled": "Uitgeschakeld",
        "two_factor_email": "E-mail",
        "two_factor_sms": "SMS",
        "hidden_menu_items": "Hidden menu items",
        "hide_ai_results": "AI-resultaten verbergen",
        "hide_player_rating": "Bedrijfsranglijst verbergen voor deelnemers",
        "show_character_memory_to_player": "Karaktergeheugen tonen aan de speler",
        "show_meeting_recap_to_player": "Verslag van de vergadering tonen aan de speler",
        "create_user_on_external_launch": "Gebruiker aanmaken bij eerste verzoek van extern systeem",
        "create_user_on_external_launch_hint": "Indien uit, krijgt een gebruiker die niet eerder door het externe systeem is aangemeld, een weigering in plaats van een sessie. Elke gebruiker die op deze manier wordt aangemaakt, neemt een plek in het abonnement in.",
        "allow_external_email_linking": "Koppeling van externe gebruiker via e-mail toestaan",
        "allow_external_email_linking_hint": "Indien aan, wordt een externe persoon gekoppeld aan een bestaande gebruiker als het externe systeem het e-mailadres vanaf zijn eigen server heeft doorgegeven. Indien uit, wordt zo'n verzoek geweigerd en wordt er geen tweede gebruiker met dat adres aangemaakt."
    },
    "users-page": {
        "import": "Importeren",
        "user": "Gebruiker",
        "roles": "Rollen",
        "effectiveness": "Effectiviteit",
        "department": "Afdeling",
        "position": "Functie",
        "status": "Status",
        "actions": " ",
        "add": "Gebruiker toevoegen",
        "add_popup": "Nieuwe gebruiker",
        "last_login_at": "Laatste login",
        "delete": "Verwijderen",
        "view": "Bekijken",
        "login": "Inloggen",
        "message": "Bericht",
        "activate": "Activeren",
        "deactivate": "Blokkeren",
        "edit_popup": "Gebruiker bewerken",
        "total_in_org": "Totaal in de organisatie",
        "multi_role_note": "Een gebruiker met meerdere rollen wordt in elke badge meegeteld",
        "filter_role": "Rol",
        "all_roles": "Alle rollen",
        "filter_activity": "Voltooide scenario's",
        "activity_played": "Ja",
        "activity_not_played": "Nee",
        "filter_activity_from": "Gespeeld sinds",
        "filter_last_login_from": "Inlogdatum",
        "filter_custom_field": "Aangepast veld",
        "filter_custom_field_value": "Waarde van “{field}”",
        "last_login_never": "Nooit ingelogd",
        "last_login_since": "Ingelogd sinds",
        "cases_progress": "Voltooide casussen",
        "cases_progress_value": "{completed} van {assigned}",
        "export": "Exporteren",
        "popup": {
            "name": "Voornaam",
            "last_name": "Achternaam",
            "patronymic": "Patroniem",
            "phone": "Telefoon",
            "timezone": "Tijdzone",
            "language": "Taal",
            "country": "Land",
            "invalid_phone": "Onjuist telefoonnummer",
            "department": "Afdeling",
            "position": "Functie",
            "effectiveness": "Effectiviteit",
            "roles": "Rollen",
            "organizations": "Organisaties",
            "blocked": "Geblokkeerd",
            "is_active": "Is actief",
            "email_verified": "E-mail is geverifieerd",
            "email_not_verified": "E-mail is niet geverifieerd",
            "subordinates": "Ondergeschikten",
            "search_subordinates": "Deelnemers zoeken...",
            "import": {
                "download_example": "Voorbeeld downloaden",
                "title": "Import van gebruikers",
                "button": "Import starten",
                "label": "Excel-bestand",
                "marker_hint": "Bij een gebruiker die al bestaat behoudt een lege cel de huidige waarde en wist een streepje (-) het veld.",
                "result_title": "Import gestart",
                "result_created": "Wordt aangemaakt: {count}",
                "result_updated": "Wordt bijgewerkt: {count}",
                "result_skipped": "Overgeslagen: {count}",
                "result_skipped_row": "Rij {row}, {email}: {reason}",
                "result_truncated": "…en nog {count} overgeslagen rijen"
            }
        }
    },
    "users-ranking-page": {
        "user": "Gebruiker",
        "roles": "Rollen",
        "effectiveness": "Effectiviteit",
        "average-effectiveness": "Gemiddeld per sessie",
        "sessions-count": "Sessies",
        "department": "Afdeling",
        "position": "Functie",
        "status": "Status",
        "export": "Exporteren",
        "actions": " "
    },
    "user-detail": {
        "games_finished": "Sessies voltooid",
        "not_found": "Gebruiker niet gevonden",
        "games_total": "Totaal",
        "username": "Gebruikersnaam",
        "phone": "Telefoon",
        "status": "Status",
        "language": "Taal",
        "timezone": "Tijdzone",
        "edit": "Bewerken",
        "department": "Afdeling",
        "position": "Functie",
        "activate": "Activeren",
        "block": "Blokkeren",
        "account": {
            "title": "Account",
            "summary": {
                "title": "Overzicht",
                "games": "Voltooide sessies",
                "place": "Plaats",
                "effectiveness": "Effectiviteit",
                "time": "Tijd"
            }
        },
        "security": {
            "title": "Beveiliging",
            "change_password_title": "Wachtwoord wijzigen",
            "change_password": "Wachtwoord wijzigen",
            "new_password": "Nieuw wachtwoord",
            "confirm_new_password": "Nieuw wachtwoord bevestigen",
            "password_requirements": "Wachtwoordeisen:",
            "password_requirements_1": "Minimaal 8 tekens - meer is beter",
            "password_requirements_2": "Ten minste één kleine letter",
            "password_requirements_3": "Ten minste één cijfer, symbool of spatie"
        },
        "statistics": {
            "title": "Statistieken"
        }
    },
    "game": {
        "character_memory": {
            "title": "Wat het karakter zich herinnert",
            "subtitle": "De herinnering aan eerdere vergaderingen waarmee het karakter dit spel start",
            "preview_subtitle": "De herinnering staat nog niet vast – het karakter ontvangt deze op het moment dat het spel begint",
            "unavailable": "De vorige vergadering is niet beschikbaar voor het karakter: het begint het gesprek zonder zich deze te herinneren.",
            "agreements": "Afspraken",
            "player_commitments": "Toezeggingen van de speler",
            "character_commitments": "Toezeggingen van het karakter",
            "open_issues": "Openstaande vragen",
            "facts": "Genoemde feiten",
            "attitude": "Houding tegenover de speler",
            "evaluation_passed": "De beoordelingsresultaten van die vergadering zijn aan het karakter doorgegeven",
            "evaluation_not_ready": "De beoordeling van die vergadering is nog niet klaar – het karakter ontvangt deze zodra ze is berekend.",
            "evaluation_hidden": "De beoordelingsteksten zijn verborgen door de organisatie-instellingen.",
            "overall_effectiveness": "Totale effectiviteit",
            "outcome": {
                "deal": "Akkoord",
                "partial": "Gedeeltelijk",
                "no_deal": "Geen akkoord",
                "unclear": "Onduidelijk"
            }
        },
        "meeting_recap": {
            "title": "Verslag van de vergadering",
            "outcome": "Uitkomst",
            "agreements": "Afspraken",
            "player_commitments": "Toezeggingen van de speler",
            "character_commitments": "Toezeggingen van het karakter",
            "open_issues": "Openstaande vragen",
            "facts": "Genoemde feiten",
            "pending": "Het verslag van de vergadering wordt nog voorbereid. Kom hier iets later terug.",
            "unavailable": "Het verslag van deze vergadering kon niet worden opgesteld.",
            "none": "Er is geen verslag voor dit spel."
        },
        "title": "Sessie",
        "team": "Team",
        "expert": "Expert",
        "points": "punten",
        "your_result": "Uw resultaat",
        "joined_at": "Aangemeld:",
        "ended_at": "Voltooiingsdatum",
        "min": "min.",
        "duration": "Duur",
        "from_average": "van gemiddeld",
        "ai_expert": "AI-expert",
        "ai_evaluation_in_progress": "AI-beoordeling is bezig",
        "delete_ai_request": "AI-feedback verwijderen",
        "ai_expert_refresh": "AI-resultaten vernieuwen",
        "ai_expert_refresh_rejected": {
            "evaluation_not_completed": "De AI-resultaten kunnen op dit moment niet worden vernieuwd: de AI-beoordeling is nog bezig.",
            "answer_pending": "De AI-resultaten kunnen op dit moment niet worden vernieuwd: het antwoord van de AI is nog niet binnen.",
            "recognition_pending": "De AI-resultaten kunnen op dit moment niet worden vernieuwd: de opname wordt nog getranscribeerd.",
            "recognition_has_no_speech": "In de opname is geen spraak herkend, daarom kunnen de AI-resultaten niet worden vernieuwd.",
            "recognition_has_too_little_speech": "In de opname is vrijwel geen gesprek tussen de deelnemers te horen, daarom is er geen AI-beoordeling uitgevoerd.",
            "no_ai_evaluation": "Deze sessie heeft geen AI-beoordeling meer.",
            "game_evaluation_blocked": "De sessie heeft niet plaatsgevonden of is geannuleerd, daarom is AI-beoordeling niet beschikbaar."
        },
        "ai_expert_unavailable": {
            "recognition_has_no_speech": "In de opname is geen spraak herkend, daarom is er geen AI-beoordeling uitgevoerd.",
            "recognition_has_too_little_speech": "In de opname is vrijwel geen gesprek tussen de deelnemers te horen, daarom is er geen AI-beoordeling uitgevoerd.",
            "game_evaluation_blocked": "De sessie heeft niet plaatsgevonden of is geannuleerd, daarom is AI-beoordeling niet beschikbaar."
        },
        "ai_expert_refresh_failed": "Het is niet gelukt om de AI-resultaten te vernieuwen.",
        "speaker_mapping": {
            "title": "Deelnemers en stemmen",
            "voice": "Stem {number}",
            "unknown": "Niet geïdentificeerd",
            "needs_review": "Controleer de deelnemers",
            "needs_review_hint": "De deelnemers zijn mogelijk onjuist geïdentificeerd: controleer of de AI-feedback bij de juiste personen terecht is gekomen.",
            "failed": "De deelnemers konden niet automatisch worden geïdentificeerd.",
            "unavailable": "De AI-provider was niet beschikbaar; de deelnemers worden bij de volgende beoordeling geïdentificeerd.",
            "empty": "Het transcript bevat geen spraak waarmee deelnemers kunnen worden geïdentificeerd.",
            "corrected_manually": "Handmatig gecorrigeerd",
            "under_reevaluation": "De AI-beoordeling met deze deelnemers is bezig. Totdat deze is afgerond, toont de pagina de vorige resultaten.",
            "confirm": "Deelnemers zijn correct",
            "review": "Controleren",
            "dialog_hint": "Wijs elke stem een deelnemer toe. Na het opslaan wordt de AI-feedback opnieuw aangevraagd.",
            "save": "Opslaan",
            "cancel": "Annuleren",
            "confirmed": "Deelnemers bevestigd",
            "fixed": "Deelnemers gecorrigeerd, AI-feedback opnieuw aangevraagd",
            "action_failed": "Actie kon niet worden voltooid"
        },
        "ai_expert_created": "Het beoordelingsproces is gestart. Dit duurt enkele minuten. U kunt de pagina verlaten; we sturen een melding zodra de beoordeling beschikbaar is.",
        "expert_already_requested": "Beoordeling is al door een andere deelnemer aangevraagd",
        "request_expert": "Expert aanvragen",
        "assign_expert": "Expert toewijzen",
        "ai_process": "Even geduld, wordt verwerkt",
        "analyzing_results": "Sessieresultaten analyseren...",
        "complete_expert_request": "Beoordeling voltooien",
        "tabs": {
            "description": {
                "title": "Scenario Beschrijving",
                "subtitle": "Sessie-informatie en regels",
                "situation": "Situatie",
                "your_role": "Uw rol",
                "player_role": "Rol van speler: {name}",
                "team_tab": "Team {team}",
                "empty": "Deze sessie heeft geen beschrijvingen.",
                "load_error": "Kon de beschrijving niet laden. Probeer het later opnieuw."
            },
            "results": {
                "title": "Resultaten",
                "effectiveness_summary": "Team effectiviteit",
                "your_effectiveness": "Uw effectiviteit",
                "parameters_section": "Parameters",
                "parameter": "Parameter",
                "target": "Doel",
                "coefficient": "Coëfficiënt",
                "value": "Overeenstemming",
                "points": "Punten",
                "points_short": "punten",
                "combinations": "Combinaties",
                "combination_bonus": "Combinatiebonus",
                "questions": "Vragen",
                "question": "Vraag",
                "answer": "Antwoord",
                "total": "Totaal"
            },
            "comments": {
                "title": "Videoanalyse",
                "comments": "Reacties",
                "no_comments": "Nog geen reacties",
                "no_video": "Video niet beschikbaar",
                "video_processing": "Video wordt verwerkt...",
                "count": "reacties",
                "delete": "Verwijderen",
                "edit": "Bewerken",
                "popup": {
                    "add": "Opmerking toevoegen",
                    "edit": "Opmerking bewerken",
                    "comment": "Opmerking",
                    "player": "Deelnemer",
                    "all": "Aan allen"
                }
            },
            "feedback": {
                "title": "Sessiebeoordeling",
                "no_feedback": "Nog geen beoordelingen",
                "no_feedback_description": "Feedback voor deze sessie is nog niet toegevoegd",
                "overall_score": "Totale Score",
                "skills_evaluated": "{count} vaardigheden beoordeeld",
                "no_comment": "Geen opmerking opgegeven",
                "score_button": "Deelnemer beoordelen",
                "player": "Deelnemer",
                "author": "Auteur",
                "download": "Video downloaden",
                "download_transcript": "Transcriptie downloaden",
                "evaluators": {
                    "ai": "Expert",
                    "expert": "Expert",
                    "player": "Deelnemer",
                    "manager": "Manager",
                    "head": "Leidinggevende"
                },
                "popup": {
                    "score": {
                        "title": "Deelnemersbeoordeling",
                        "comment": "Opmerking",
                        "error": "U moet alle deelnemersvaardigheden beoordelen",
                        "save_error": "De beoordeling kon niet worden opgeslagen. Mogelijk hebt u geen toestemming om deze deelnemer te beoordelen."
                    }
                }
            },
            "checklist": {
                "title": "Checklist",
                "total": "Geslaagde items",
                "pass": "Geslaagd",
                "fail": "Niet geslaagd",
                "cannot_assess": "Niet te beoordelen",
                "comment": "Algemene opmerking",
                "category": "Categorie",
                "author": "Beoordelaar",
                "player": "Deelnemer",
                "passed_of": "{passed} van {total}",
                "evidence": "Bewijs",
                "rationale": "Motivering",
                "no_results": "Nog geen checklistbeoordeling",
                "no_results_description": "Deze sessie is nog niet beoordeeld aan de hand van een checklist"
            }
        }
    },
    "scenario": {
        "steps": {
            "information": {
                "create_new_ai_profile": "Nieuw maken",
                "edit_ai_profile": "Bewerken",
                "delete_ai_profile": "Verwijderen",
                "confirm_delete_ai_profile": "Weet u zeker dat u dit AI-profiel wilt verwijderen?",
                "first_header": "Basisinstellingen",
                "second_header": "AI-deelnemer",
                "third_header": "Scenariobeschrijving",
                "is_public": "Openbaar",
                "is_public_hint": "Indien ingeschakeld — scenario is beschikbaar voor deelnemers.",
                "title": "Informatie",
                "subtitle": "Basisgegevens scenario",
                "image": "scenario-afbeelding",
                "field_title": "Titel",
                "competence": "Competentie",
                "description": "Beschrijving",
                "description_a": "Beschrijving voor team A",
                "description_b": "Beschrijving voor team B",
                "next_scenario_label": "Volgend scenario",
                "next_scenario_placeholder": "Niet geselecteerd",
                "next_scenario_hint": "Na voltooiing van de sessie met dit scenario wordt automatisch een sessie met het volgende scenario aangemaakt.",
                "memory_header": "Koppeling met de volgende vergadering",
                "memory_group_evaluation": "De beoordeling van de volgende vergadering",
                "memory_group_character": "Het karakter van de volgende vergadering",
                "memory_pass_to_next": "herinnert zich deze vergadering",
                "memory_pass_to_next_hint": "Het karakter van het volgende scenario begint het gesprek alsof het zijn gesprekspartner al kent: het ontvangt een korte samenvatting van deze vergadering, de afspraken, de toezeggingen van beide partijen, de openstaande vragen en de genoemde feiten. De opname van het gesprek en letterlijke citaten worden niet doorgegeven. Schakel dit in wanneer de volgende vergadering een vervolg is op deze: een tweede onderhandelingsronde, een terugkerend één-op-één-gesprek.",
                "memory_pass_evaluation_to_next": "kent de beoordeling van deze vergadering",
                "memory_pass_evaluation_to_next_hint": "Samen met het geheugen ontvangt het karakter de feedbackteksten over de vaardigheden en het eindresultaat van deze vergadering, waardoor het zich kan gedragen als een coach die onthoudt wat de speler goed heeft gedaan.",
                "memory_evaluate_next_with_agreements": "houdt rekening met de afspraken van deze vergadering",
                "memory_evaluate_next_with_agreements_hint": "Bij de beoordeling van de volgende vergadering ziet de AI-expert de afspraken, de toezeggingen van beide partijen en de openstaande vragen van deze vergadering, en kan controleren of de speler zijn woord heeft gehouden. Scores en beoordelingsteksten van de vorige vergadering worden niet aan de expert doorgegeven, zodat ze de nieuwe beoordeling niet beïnvloeden.",
                "ai_profile": "AI-profiel",
                "ai_profile_placeholder": "Alleen voor AI-wedstrijden",
                "ai_description": "AI-beschrijving",
                "optimize_ai_description": "Optimize with AI",
                "optimizing_in_progress": "AI is optimizing the description. Please wait...",
                "optimize_error": "Failed to optimize the description. Please try again.",
                "ai_description_hint": "Het schrijven van een effectieve AI-prompt vereist ervaring. Een slecht geschreven prompt kan leiden tot onvoorspelbaar scenariogedrag. Als u het niet zeker weet, gebruik dan de knop «Optimaliseren met AI», probeer de scenariogeneratie of neem contact op met uw manager.",
                "knowledge_base_header": "Kennisbank",
                "knowledge_base_documents": "Kennisbankdocumenten",
                "knowledge_base_documents_hint": "Documenten toevoegen om context te bieden aan de AI-speler",
                "knowledge_base_no_documents": "Geen documenten beschikbaar. Upload documenten op de pagina \"Kennisbank\".",
                "knowledge_base_chunks": "{count} fragmenten",
                "knowledge_base_purpose_voice": "AI-sessie",
                "knowledge_base_purpose_eval": "Beoordeling"
            },
            "settings": {
                "title": "Instellingen",
                "subtitle": "Configuratie scenario",
                "min_players": "Min. deelnemers",
                "min_players_hint": "Getal tussen 2 en 20",
                "max_players": "Max. deelnemers",
                "max_players_hint": "Getal tussen 2 en 20",
                "protocol_time": "Tijd voor protocol (min)",
                "protocol_time_hint": "Getal tussen 1 en 1440",
                "preparation_time": "Voorbereidingstijd (min)",
                "preparation_time_hint": "Getal tussen 0 en 1440. 0 - de beschrijving is direct zichtbaar",
                "game_duration": "Sessieduur (min)",
                "game_duration_hint": "Getal tussen 1 en 60",
                "is_team": "Scenario voor teams",
                "is_camera_required": "Deelnemerscamera's vereist",
                "is_self_rated": "Deelnemers kunnen zichzelf beoordelen",
                "is_each_other_rated": "Deelnemers kunnen elkaar beoordelen",
                "is_expert_rated": "Expertbeoordeling beschikbaar",
                "is_ai_rated": "AI-beoordeling beschikbaar",
                "show_results": "Resultaten tonen",
                "automatically": "automatisch",
                "manually": "handmatig"
            },
            "parameters": {
                "title": "Parameters",
                "subtitle": "Parameters van de deelnemer",
                "field_title": "Titel",
                "team_a": "Team A",
                "team_b": "Team B",
                "player_a": "Deelnemer A",
                "player_b": "Deelnemer B",
                "points": "Punten",
                "ratio": "Verhouding",
                "add": "Parameter toevoegen"
            },
            "questions": {
                "title": "Vragen",
                "subtitle": "Vragen voor deelnemers",
                "question": "Vraag",
                "team": "Team",
                "team_placeholder": "Selecteer team",
                "answers": "Antwoorden",
                "points": "Punten",
                "select_answers": "Antwoorden selecteren",
                "add_combination": "Combinatie toevoegen",
                "add_question": "Vraag toevoegen"
            },
            "next": "Volgende",
            "previous": "Vorige",
            "save": "Opslaan"
        },
        "saved": "Scenario opgeslagen",
        "to_list": "Terug naar lijst",
        "add_detail": "Scenario toevoegen",
        "edit_detail": "Scenario bewerken"
    },
    "notifications": {
        "title": "Meldingen",
        "mark_unread": "Alles als ongelezen markeren",
        "mark_read": "Alles als gelezen markeren",
        "delete_all": "Alles verwijderen",
        "no_new": "Geen meldingen gevonden",
        "system": "Systeem",
        "evaluation": {
            "ready": {
                "subject": "Sessiebeoordeling #:gameNumber",
                "text": "De sessie is beoordeeld door een expert"
            }
        },
        "game": {
            "created": {
                "game_assigned": "Er is een sessie aan u toegewezen",
                "role": "Rol:"
            },
            "proposal": {
                "subject": "Afstemming van speeltijd",
                "time": "Tijd:",
                "description": "Bevestig of stel uw eigen optie voor"
            },
            "agreed": {
                "subject": "Speeltijd overeengekomen",
                "time": "Tijd:",
                "description": "De beschrijving en voorbereidingsopties zijn :preparationTime minuten voor de start beschikbaar",
                "description_zero": "U kunt nu de scenariobeschrijving bekijken en u voorbereiden"
            },
            "preparation": {
                "subject": "Voorbereiding op de sessie",
                "text": "De voorbereiding op de sessie is beschikbaar."
            },
            "started": {
                "subject": "Sessie #:gameNumber is begonnen",
                "text": "Meedoen!"
            },
            "missed": {
                "subject": "De sessie #:gameNumber is gemist",
                "text": "Sorry, u hebt de sessie gemist"
            },
            "completed": {
                "subject": "Sessie #:gameNumber voltooid",
                "text": "Succesvolle sessie"
            },
            "failed": {
                "subject": "Sessie #:gameNumber mislukt",
                "text": "Onsuccesvol afgerond"
            },
            "results": {
                "proposed": {
                    "subject": "Sessieprotocol #:gameNumber voorgesteld",
                    "text": "Overeenkomst beschikbaar"
                },
                "declined": {
                    "subject": "Sessieprotocol #:gameNumber afgewezen",
                    "text": "Voorstel afgewezen"
                },
                "not_agreed": {
                    "subject": "Sessie #:gameNumber: de partijen zijn niet tot een akkoord gekomen",
                    "text": "De kapitein van de tegenstander heeft aangegeven dat de partijen niet tot een akkoord zijn gekomen. De sessie is niet succesvol geëindigd en de resultaten zijn niet meegeteld."
                }
            },
            "meeting": {
                "ended-player": {
                    "subject": "Sessievergadering #:gameNumber afgerond",
                    "text": "Wacht alstublieft op de resultaten."
                },
                "ended-captain": {
                    "subject": "Sessievergadering #:gameNumber afgerond",
                    "text_fill": "Vul het protocol in, alstublieft.",
                    "text_wait": "Wacht alstublieft tot het protocol is ingevuld.",
                    "protocol_time": "Tijd voor protocol (minuten): :protocolTime"
                }
            }
        }
    },
    "profile": {
        "avatar_allowed": "Toegestaan: JPG, GIF of PNG. Max. grootte 2MB",
        "avatar_label_choose": "Kiezen",
        "avatar_label_your_avatar": "uw avatar",
        "name": "Voornaam",
        "last_name": "Achternaam",
        "patronymic": "Patroniem",
        "phone": "Telefoon",
        "timezone": "Tijdzone",
        "language": "Taal",
        "country": "Land",
        "invalid_phone": "Onjuist telefoonnummer",
        "save_changes": "Wijzigingen opslaan",
        "account": "Account",
        "security": "Beveiliging",
        "statistics": "Statistieken",
        "notifications": "Meldingen",
        "change_password_title": "Wachtwoord wijzigen",
        "change_password": "Wachtwoord wijzigen",
        "current_password": "Huidig wachtwoord",
        "new_password": "Nieuw wachtwoord",
        "confirm_new_password": "Nieuw wachtwoord bevestigen",
        "password_requirements": "Wachtwoordeisen:",
        "password_requirements_1": "Minimaal 8 tekens - meer is beter",
        "password_requirements_2": "Ten minste één kleine letter",
        "password_requirements_3": "Ten minste één cijfer, symbool of spatie",
        "two_factor_title": "Tweefactorauthenticatie",
        "two_factor_description": "Voeg een extra beveiligingslaag toe aan uw account",
        "two_factor_org_enforced": "Tweefactorauthenticatie is verplicht door uw organisatie",
        "two_factor_method": "Authenticatiemethode",
        "two_factor_disabled": "Uitgeschakeld",
        "two_factor_email": "E-mail",
        "two_factor_sms": "SMS",
        "two_factor_save": "2FA-instellingen opslaan"
    },
    "auth": {
        "password": "Wachtwoord",
        "new_password": "Nieuw wachtwoord",
        "remember": "Onthoud mij",
        "timezone": "Tijdzone",
        "forgot": "Wachtwoord vergeten",
        "login": "Inloggen",
        "login_title": "Inloggen",
        "new_password_title": "Wachtwoord wijzigen",
        "change_password": "Opslaan",
        "country": "Land",
        "invalid_phone": "Onjuist telefoonnummer",
        "privacy_policy_title": "Privacybeleid",
        "privacy_policy_text": "Tekst privacybeleid...",
        "first_time": "Nieuw op ons platform?",
        "registration": "Account aanmaken",
        "forgot_title": "Wachtwoord vergeten?",
        "forgot_description": "Voer uw e-mail in en we sturen instructies om uw wachtwoord te resetten",
        "send_reset_link": "Resetlink verzenden ",
        "back_to_login": "Terug naar inloggen",
        "register": "Registreren",
        "name": "Voornaam",
        "last_name": "Achternaam",
        "patronymic": "Patroniem",
        "phone": "Telefoon",
        "enter_password": "Voer wachtwoord in",
        "confirm_password": "Wachtwoord bevestigen",
        "not_first_time": "Heeft u al een account?",
        "agree_too": "Ik ga akkoord met",
        "privacy_policy": "privacybeleid en voorwaarden",
        "accept": " Ik ga akkoord ",
        "password_validation": "Veld moet minstens één hoofdletter, kleine letter, speciaal teken en cijfer bevatten met min. 8 tekens",
        "password_confirm_error": "Het veld Wachtwoord bevestigen komt niet overeen",
        "set_password": "Nieuw wachtwoord instellen",
        "reset_password": "Wachtwoord opnieuw instellen",
        "for": "voor",
        "sign_in_to_for": "Inloggen bij {app} voor {org}",
        "registration_title": "Registratie",
        "verify_title": "E-mailbevestiging",
        "verify_head": "Bevestig uw e-mail",
        "verify_description": "Link voor accountactivatie is naar uw e-mailadres verzonden. Volg de link om door te gaan.",
        "verify_new_link": "Er is een nieuwe verificatielink verzonden naar het e-mailadres dat u tijdens de registratie hebt opgegeven.",
        "verify_send": "Verificatiemail opnieuw versturen",
        "verify_spam": "U hebt te veel verzoeken gedaan, probeer het over een minuut opnieuw",
        "verify_logout": "Uitloggen",
        "two_factor_title": "Tweefactorauthenticatie",
        "two_factor_description_email": "We hebben een verificatiecode naar uw e-mailadres gestuurd. Voer de code hieronder in.",
        "two_factor_description_sms": "We hebben een verificatiecode naar uw telefoonnummer gestuurd. Voer de code hieronder in.",
        "two_factor_code_label": "Verificatiecode",
        "two_factor_code_placeholder": "Voer 6-cijferige code in",
        "two_factor_verify": "Verifiëren",
        "two_factor_resend": "Code opnieuw versturen",
        "two_factor_resend_success": "Er is een nieuwe code verzonden",
        "two_factor_back": "Terug naar inloggen"
    },
    "filepond": {
        "upload": "Uploaden",
        "upload_complete": "Upload voltooid",
        "uploading": "Bezig met uploaden",
        "loading": "Laden",
        "tap_to_cancel": "tik om te annuleren",
        "tap_to_undo": "tik om ongedaan te maken",
        "upload_aborted": "Upload geannuleerd",
        "file_too_large": "Bestand is te groot"
    },
    "text-editor": {
        "image": "Sleep uw afbeelding eenvoudig naar de editor"
    },
    "webrtc": {
        "ready_to_start": "Klaar om te starten",
        "connected": "Verbonden - spreek nu!",
        "connection_lost": "Verbinding verbroken. Probeer het opnieuw."
    },
    "device_settings": {
        "title": "Instellingen audio- en videoapparaten",
        "speaker": "Luidspreker/Audio-uitvoer",
        "refresh_devices": "Apparaten vernieuwen",
        "speaker_switch_unsupported": "Luidsprekerwissel wordt niet ondersteund in deze browser"
    },
    "device_setup": {
        "mic_level": "Microfoonniveau",
        "mic_on": "Aan",
        "mic_off": "Uit",
        "cam_on": "Aan",
        "cam_off": "Uit"
    },
    "device_test": {
        "title": "Audioapparaten testen",
        "speaker_test": "Luidspreker-test",
        "speaker_hint": "Klik op de knop om testgeluiden af te spelen via de geselecteerde luidspreker",
        "play_sound": "Testgeluid afspelen",
        "playing": "Afspelen...",
        "speaker_success": "Geluid afgespeeld ✓",
        "mic_test": "Microfoon-test",
        "mic_hint": "Klik op de knop en spreek in je microfoon om te controleren of deze werkt",
        "volume_level": "Volumeniveau",
        "speak_now": "Spreek nu...",
        "seconds_short": "s",
        "start_mic_test": "Microfoon testen",
        "testing": "Testen...",
        "test_again": "Opnieuw testen",
        "mic_success": "De microfoon werkt correct!",
        "mic_fail": "Microfoonprobleem gedetecteerd",
        "mic_fail_hint": "Geen geluid gedetecteerd. Controleer of je microfoon is aangesloten, niet gedempt is en correct is geselecteerd in de instellingen."
    },
    "ai_assistant_types": {
        "type": "Type",
        "negotiation": "Onderhandeling",
        "feedback": "Feedback",
        "ai_profile": "AI-sessie"
    },
    "Login": "Inloggen",
    "UI Elements": "UI-elementen",
    "Forms & Tables": "Formulieren & Tabellen",
    "Welcome": "Welkom",
    "Pages": "Pagina's",
    "Charts & Maps": "Grafieken & Kaarten",
    "Others": "Overig",
    "Typography": "Typografie",
    "Cards": "Kaarten",
    "Basic": "Basis",
    "Advance": "Uitgebreid",
    "Widgets": "Widgets",
    "Components": "Componenten",
    "Alert": "Melding",
    "Close Alert": "Melding sluiten",
    "Avatar": "Avatar",
    "Badge": "Badge",
    "Button": "Knop",
    "Calendar": "Kalender",
    "Image": "Afbeelding",
    "Pagination": "Paginering",
    "Progress Circular": "Circulaire voortgang",
    "Progress Linear": "Lineaire voortgang",
    "Autocomplete": "Autocompleet",
    "Tooltip": "Tooltip",
    "Slider": "Schuifregelaar",
    "Date Time Picker": "Datum-tijdkiezer",
    "Select": "Selecteren",
    "Switch": "Schakelaar",
    "Checkbox": "Selectievakje",
    "Radio": "Keuzerondje",
    "Textarea": "Tekstvak",
    "Rating": "Beoordeling",
    "File Input": "Bestandsinvoer",
    "Otp Input": "OTP-invoer",
    "Form Layout": "Formulierindeling",
    "Form Validation": "Formuliervalidatie",
    "Charts": "Grafieken",
    "Apex Chart": "Apex-grafiek",
    "Chartjs": "Chartjs",
    "Account Settings": "Accountinstellingen",
    "User Profile": "Gebruikersprofiel",
    "FAQ": "FAQ",
    "Dialog Examples": "Dialoogvoorbeelden",
    "Pricing": "Prijzen",
    "List": "Lijst",
    "Edit": "Bewerken",
    "Nav Levels": "Navigatieniveaus",
    "Level 2.1": "Niveau 2.1",
    "Level 2.2": "Niveau 2.2",
    "Level 3.1": "Niveau 3.1",
    "Level 3.2": "Niveau 3.2",
    "Raise Support": "Ondersteuning aanvragen",
    "Documentation": "Documentatie",
    "Dashboards": "Dashboards",
    "Analytics": "Analytics",
    "Apps & Pages": "Apps & Pagina's",
    "Email": "E-mail",
    "Chat": "Chat",
    "Invoice": "Factuur",
    "Preview": "Voorbeeld",
    "Add": "Toevoegen",
    "User": "Gebruiker",
    "View": "Bekijken",
    "Login v1": "Inloggen v1",
    "Login v2": "Inloggen v2",
    "Register v1": "Registreren v1",
    "Register v2": "Registreren v2",
    "Register": "Registreren",
    "Forget Password v1": "Wachtwoord vergeten v1",
    "Forget Password v2": "Wachtwoord vergeten v2",
    "Forgot Password v1": "Wachtwoord vergeten v1",
    "Forgot Password v2": "Wachtwoord vergeten v2",
    "Forgot Password": "Wachtwoord vergeten",
    "Reset Password v1": "Wachtwoord resetten v1",
    "Reset Password v2": "Wachtwoord resetten v2",
    "Reset Password": "Wachtwoord resetten",
    "Miscellaneous": "Diversen",
    "Coming Soon": "Binnenkort",
    "Not Authorized": "Niet geautoriseerd",
    "Under Maintenance": "Onderhoud bezig",
    "Error": "Fout",
    "Statistics": "Statistieken",
    "Actions": "Acties",
    "Access Control": "Toegangsbeheer",
    "User Interface": "Gebruikersinterface",
    "CRM": "CRM",
    "eCommerce": "E-commerce",
    "Icons": "Pictogrammen",
    "Chip": "Chip",
    "Dialog": "Dialoog",
    "Expansion Panel": "Uitklapbaar paneel",
    "Combobox": "Combobox",
    "Textfield": "Tekstveld",
    "Range Slider": "Bereikschuif",
    "Menu": "Menu",
    "Snackbar": "Snackbar",
    "Tabs": "Tabs",
    "Form Elements": "Formulierelementen",
    "Form Layouts": "Formulierindelingen",
    "Authentication": "Authenticatie",
    "Page Not Found - 404": "Pagina niet gevonden - 404",
    "Not Authorized - 401": "Niet geautoriseerd - 401",
    "Server Error - 500": "Serverfout - 500",
    "2": "2",
    "Forms": "Formulieren",
    "Timeline": "Tijdlijn",
    "Disabled Menu": "Uitgeschakeld menu",
    "Help Center": "Helpcentrum",
    "Verify Email": "E-mail verifiëren",
    "Verify Email v1": "E-mail verifiëren v1",
    "Verify Email v2": "E-mail verifiëren v2",
    "Two Steps": "Twee stappen",
    "Two Steps v1": "Twee stappen v1",
    "Two Steps v2": "Twee stappen v2",
    "Custom Input": "Aangepaste invoer",
    "Extensions": "Extensies",
    "Tour": "Rondleiding",
    "Register Multi-Steps": "Registratie in meerdere stappen",
    "Wizard Examples": "Wizardvoorbeelden",
    "Checkout": "Afrekenen",
    "Create Deal": "Deal aanmaken",
    "Property Listing": "Vastgoedoverzicht",
    "Roles & Permissions": "Rollen & Rechten",
    "Roles": "Rollen",
    "Simple Table": "Eenvoudige tabel",
    "Tables": "Tabellen",
    "Data Table": "Gegevenstabel",
    "Permissions": "Rechten",
    "Apps": "Apps",
    "Misc": "Diversen",
    "Wizard Pages": "Wizardpagina's",
    "Form Wizard": "Formulierwizard",
    "Numbered": "Genummerd",
    "3": "3",
    "ecommerce": "e-commerce",
    "Ecommerce": "E-commerce",
    "Editors": "Editors",
    "Front Pages": "Voorpagina's",
    "Landing": "Landing",
    "checkout": "afrekenen",
    "Payment": "Betaling",
    "Swiper": "Swiper",
    "Product": "Product",
    "Category": "Categorie",
    "Order": "Bestelling",
    "Details": "Details",
    "Customer": "Klant",
    "Manage Review": "Beoordelingen beheren",
    "Referrals": "Verwijzingen",
    "Settings": "Instellingen",
    "Overview": "Overzicht",
    "My Course": "Mijn cursus",
    "Course Details": "Cursusdetails",
    "Academy": "Academie",
    "Logistics": "Logistiek",
    "Dashboard": "Dashboard",
    "Fleet": "Vloot",
    "5": "5",
    "10": "10",
    "20": "20",
    "25": "25",
    "50": "50",
    "100": "100",
    "skill_reports": {
        "skill_development_report": "Vaardigheidsrapport",
        "generate": "Genereren",
        "generate_description": "Een uitgebreid vaardigheidsrapport genereren voor een geselecteerde periode",
        "manager_description": "Vaardigheidsrapporten genereren voor medewerkers in uw organisatie",
        "date": "Datum",
        "competence": "Competentie",
        "period": "Periode",
        "status_label": "Status",
        "actions": "Acties",
        "employee": "Medewerker",
        "view": "Rapport bekijken",
        "download_pdf": "PDF downloaden",
        "no_reports": "Nog geen rapporten gegenereerd",
        "data_not_available": "Rapportgegevens zijn nog niet beschikbaar",
        "generation_failed": "Rapportgeneratie mislukt",
        "retry": "Opnieuw proberen",
        "rate_limit_exceeded": "Limiet voor rapportgeneratie bereikt. Probeer het later opnieuw.",
        "too_many_pending": "U heeft te veel rapporten in behandeling. Wacht tot ze zijn voltooid.",
        "no_games_for_report": "Geen voltooide sessies gevonden voor de geselecteerde periode en competentie. Het rapport kan niet worden gegenereerd.",
        "report_already_exists": "Een rapport met deze parameters bestaat al. Controleer de lijst hieronder.",
        "period_too_long": "De rapportperiode mag niet langer zijn dan één jaar.",
        "invalid_parameters": "Controleer de competentie en de periode",
        "filter_by_employee": "Filteren op medewerker...",
        "batch": {
            "mode_single": "Eén rapport",
            "mode_batch": "Batch",
            "load_employees": "Medewerkers tonen",
            "sessions": "Sessies",
            "no_candidates": "Geen medewerkers met afgeronde sessies voor de gekozen competentie en periode",
            "generate_selected": "Genereren ({count})",
            "selected_limit": "Je kunt maximaal {max} medewerkers tegelijk selecteren",
            "progress": "{ready} van {total} klaar",
            "failed_count": "Mislukt: {count}",
            "status_unknown": "Status onbekend",
            "status_unknown_hint": "Het rapport is niet in de lijst gevonden — bekijk de rapportentabel hieronder",
            "reused": "Hergebruikte rapporten: {count} — gegenereerd in de afgelopen {hours} uur en niet opnieuw aangemaakt",
            "reused_badge": "Hergebruikt",
            "reused_on": "Gegenereerd op {date}",
            "download_all": "Alles downloaden",
            "toggle_details": "Inhoud van de batch tonen",
            "dismiss_confirm": "Deze batch wordt nog gegenereerd. Van het scherm verwijderen? De voortgang en de knop “Alles downloaden” gaan verloren; de rapporten blijven in de lijst hieronder staan.",
            "archive_unavailable": "Het archief kon niet worden samengesteld: sommige rapporten zijn nog niet klaar of niet meer beschikbaar",
            "archive_failed": "Het archief kon niet worden gedownload",
            "archive_building": "Archief samenstellen…",
            "archive_build_failed": "Het archief kon niet worden samengesteld. Probeer het opnieuw.",
            "candidates_failed": "De lijst met medewerkers kon niet worden geladen",
            "stale_selection": "Sommige geselecteerde medewerkers zijn niet meer beschikbaar. De lijst is bijgewerkt — maak opnieuw een keuze."
        },
        "quota": {
            "remaining_hour": "Rapportlimiet: {limit} per uur. U kunt er nu nog {remaining} aanvragen. Selecteer minder medewerkers of probeer het opnieuw om {time}.",
            "remaining_day": "Rapportlimiet: {limit} per dag. U kunt er nu nog {remaining} aanvragen. Selecteer minder medewerkers of probeer het opnieuw om {time}.",
            "exhausted_hour": "Rapportlimiet ({limit} per uur) bereikt. Deze wordt om {time} opnieuw ingesteld.",
            "exhausted_day": "Rapportlimiet ({limit} per dag) bereikt. Deze wordt om {time} opnieuw ingesteld.",
            "too_large_hour": "Rapportlimiet: {limit} per uur. Selecteer minder medewerkers.",
            "too_large_day": "Rapportlimiet: {limit} per dag. Selecteer minder medewerkers."
        },
        "status": {
            "pending": "In afwachting",
            "collecting_data": "Gegevens verzamelen...",
            "analyzing": "AI-analyse...",
            "generating_pdf": "PDF genereren...",
            "ready": "Gereed",
            "failed": "Mislukt"
        },
        "report": {
            "kicker": "Rapport competentieontwikkeling",
            "position": "Functie",
            "department": "Afdeling",
            "period": "Periode",
            "games_count": "Uitgevoerde sessies",
            "not_specified_f": "Niet opgegeven",
            "not_specified_n": "Niet opgegeven",
            "fig": {
                "your_average": "Uw gemiddelde score",
                "company_average": "Bedrijfsgemiddelde",
                "participants": "Deelnemers in de periode",
                "skills_count": "Beoordeelde vaardigheden"
            },
            "sec": {
                "profile": "Competentieprofiel",
                "trend": "Verloop per sessie",
                "strengths": "Waarop u kunt bouwen",
                "priorities": "Drie ontwikkelprioriteiten",
                "skills": "Analyse per vaardigheid",
                "plan": "Plan voor drie maanden"
            },
            "legend": {
                "you": "Uw score",
                "company": "Bedrijfsgemiddelde"
            },
            "dotplot_caption": "Afwijking van het gemiddelde — van de grootste voorsprong naar de grootste achterstand",
            "trend_disclaimer": "Scores van afzonderlijke sessies zijn niet rechtstreeks vergelijkbaar: de moeilijkheidsgraad van de casussen verschilt per sessie. Een lagere score betekent op zichzelf niet dat de vaardigheid is teruggelopen — de grafiek is een waarneming, geen oordeel.",
            "no_comparison": "Vergelijking met het bedrijfsgemiddelde is niet beschikbaar: in deze periode hebben minder dan drie mensen sessies voor deze competentie gedaan. Het rapport is gebaseerd op absolute scores.",
            "skill": {
                "works": "Wat goed gaat",
                "blocks": "Wat in de weg zit",
                "actions": "Wat te doen",
                "out_of_ten": "van 10",
                "company_short": "bedrijf"
            },
            "level": {
                "outstanding": "Uitzonderlijk resultaat",
                "strength": "Sterk punt",
                "meets_standard": "Op bedrijfsniveau",
                "needs_attention": "Vraagt aandacht",
                "needs_development": "Ontwikkelpunt"
            },
            "plan": {
                "month": "Maand",
                "goals": "Doelen",
                "actions": "Acties"
            },
            "colophon": {
                "built_on": "Het rapport is gebaseerd op sessies uit de periode {from} — {to}. Sessies in totaal: {count}.",
                "comparison": "De vergelijking is met het bedrijfsgemiddelde over dezelfde periode. Deelnemers: {count}."
            }
        }
    },
    "api-tokens": "API-tokens",
    "api-tokens-page": {
        "select_user": "Gebruiker",
        "select_user_hint": "Selecteer een gebruiker om diens API-tokens te bekijken en te beheren.",
        "no_users_found": "Geen gebruikers gevonden",
        "no_tokens": "Deze gebruiker heeft geen API-tokens.",
        "token_name": "Naam",
        "abilities": "Bevoegdheden",
        "ability": "Bevoegdheid",
        "created_at": "Aangemaakt op",
        "last_used_at": "Laatst gebruikt op",
        "expires_at": "Vervalt op",
        "actions": " ",
        "issue_token": "Token uitgeven",
        "issue": "Uitgeven",
        "issue_failed": "Token uitgeven mislukt",
        "token": "Token",
        "plaintext_warning": "Kopieer dit token nu — het wordt niet opnieuw getoond.",
        "revoke": "Intrekken",
        "revoke_confirm": "Weet u zeker dat u dit token wilt intrekken? Integraties die ervan gebruikmaken, zullen niet meer werken."
    },
    "subscription": {
        "current_plan": "Huidig abonnement",
        "expires_at": "Verloopt: {date}",
        "no_active_plan": "Geen actief abonnement",
        "quota_warning": "Weinig tegoed over",
        "regular_games": "Reguliere sessies",
        "ai_games": "AI-sessies",
        "any_games": "Alle sessies",
        "used_of": "{used} van {limit}",
        "remaining": "{count} resterend",
        "quota_exceeded": "Functiequotum overschreden",
        "tickets_only": "Creditpakketten",
        "session_package": "Sessiepakket",
        "games_available": "Sessies",
        "users": "Gebruikers",
        "active_users": "Actieve gebruikers",
        "active_tickets": "Creditpakketten",
        "ticket_charges": "{charges} credits",
        "ticket_no_expiry": "Geen vervaldatum",
        "unlimited": "Onbeperkt",
        "no_game_limits": "Geen beperkingen op het aantal sessies"
    },
    "knowledge-base-page": {
        "provider-unsupported": "De kennisbank is niet beschikbaar met de huidige AI-provider van uw organisatie."
    },
    "maintenance": "Onderhoud",
    "maintenance-page": {
        "title": "Onderhoudsinstellingen",
        "notification_section": "Globale melding",
        "notification_placeholder": "Voer een melding in voor alle gebruikers",
        "notification_hint": "Dit bericht wordt aan alle geauthenticeerde gebruikers als waarschuwing getoond",
        "games_section": "Sessieblokkering",
        "games_blocked_label": "Nieuwe sessies blokkeren",
        "games_blocked_hint": "Indien ingeschakeld, kunnen gebruikers geen nieuwe sessies maken of starten. Bestaande sessies kunnen nog steeds worden betreden.",
        "save": "Opslaan",
        "clear": "Wissen",
        "clear_confirm": "Weet u zeker dat u de melding wilt wissen?",
        "last_updated": "Laatst bijgewerkt",
        "updated_by": "door",
        "games_blocked_message": "Onze excuses voor het ongemak. Het platform wordt momenteel onderhouden. Sessies zijn tijdelijk niet beschikbaar."
    },
    "$vuetify": {
        "badge": "Badge",
        "noDataText": "Geen gegevens beschikbaar",
        "close": "Sluiten",
        "open": "openen",
        "carousel": {
            "ariaLabel": {
                "delimiter": "scheidingsteken"
            }
        },
        "dataFooter": {
            "itemsPerPageText": "Items per pagina:",
            "itemsPerPageAll": "Alle",
            "pageText": "{0}-{1} van {2}",
            "firstPage": "Eerste pagina",
            "prevPage": "Vorige pagina",
            "nextPage": "Volgende pagina",
            "lastPage": "Laatste pagina"
        },
        "pagination": {
            "ariaLabel": {
                "root": "root",
                "previous": "vorige",
                "next": "volgende",
                "first": "eerste",
                "last": "laatste",
                "currentPage": "huidigePagina",
                "page": "pagina"
            }
        },
        "input": {
            "clear": "wissen",
            "appendAction": "appendActie",
            "prependAction": "prependActie",
            "counterSize": "tellerGrootte",
            "otp": "otp"
        },
        "fileInput": {
            "counterSize": "tellerGrootte"
        },
        "rating": {
            "ariaLabel": {
                "item": "item"
            }
        }
    },
    "candidate-page": {
        "document_title": "Interview",
        "greeting": "Hallo, {name}!",
        "intro_lead": "{organization} nodigt u uit voor een interview met een virtuele gesprekspartner voor de functie «{vacancy}».",
        "duration": "Het interview duurt ongeveer {minutes} min.",
        "requirements_title": "Wat u nodig heeft",
        "requirement_mic": "Een werkende microfoon, bij voorkeur een headset",
        "requirement_camera_required": "Camera ingeschakeld: voor dit interview is dat verplicht",
        "requirement_camera_optional": "Een camera is niet verplicht, maar het gesprek verloopt natuurlijker als u hem aanzet",
        "requirement_browser": "Een computer met een actuele versie van Chrome, Edge of Safari",
        "requirement_network": "Een stabiele internetverbinding en een rustige plek waar u niet gestoord wordt",
        "continue": "Doorgaan",
        "consent": {
            "accept": "Ik heb de tekst gelezen en geef toestemming voor de verwerking van mijn persoonsgegevens",
            "back": "Terug",
            "start": "Interview starten"
        },
        "terminal": {
            "finished": {
                "title": "Bedankt!",
                "text": "Het interview is afgerond en het resultaat is naar de recruiter gestuurd — die neemt contact met u op. U kunt deze pagina sluiten."
            },
            "already_completed": {
                "title": "Interview al voltooid",
                "text": "Via deze link is het interview al afgerond. Neem contact op met de recruiter als u het nog een keer moet doen."
            },
            "not_found": {
                "title": "Link niet gevonden",
                "text": "Mogelijk bevat het adres een typefout, of is de link niet meer geldig. Controleer de e-mail van de recruiter of neem contact op."
            },
            "session_conflict": {
                "title": "U bent ingelogd op een ander account",
                "text": "Log uit bij het huidige account of open de link in een privévenster van uw browser."
            },
            "link_revoked": {
                "title": "Toegang via de link is gesloten",
                "text": "De recruiter heeft deze link ingetrokken. Neem contact op voor een nieuwe link."
            },
            "link_expired": {
                "title": "De link is verlopen",
                "text": "Neem contact op met de recruiter, zodat deze een nieuwe link kan uitgeven."
            },
            "attempts_exhausted": {
                "title": "Geen pogingen meer over",
                "text": "Alle beschikbare pogingen voor deze link zijn gebruikt. Neem contact op met de recruiter."
            },
            "unavailable": {
                "title": "Nu starten is niet mogelijk",
                "text": "Probeer het later opnieuw of neem contact op met de recruiter."
            },
            "rate_limited": {
                "title": "Te veel pogingen",
                "text": "Wacht een minuut en vernieuw de pagina."
            },
            "aborted": {
                "title": "Het interview is niet gestart",
                "text": "Vernieuw de pagina en probeer het opnieuw. Als dat niet helpt, neem dan contact op met de recruiter."
            },
            "generic": {
                "title": "Er is iets misgegaan",
                "text": "Vernieuw de pagina en probeer het opnieuw. Als dat niet helpt, neem dan contact op met de recruiter."
            }
        }
    },
    "recruiting-page": {
        "title": "Werving",
        "create": "Vacature aanmaken",
        "edit": "Vacature bewerken",
        "empty": "Nog geen vacatures",
        "load_error": "De lijst met vacatures kon niet worden geladen",
        "retry": "Opnieuw proberen",
        "back": "Terug naar vacatures",
        "open": "Kandidaten",
        "archive": "Archiveren",
        "no_expiry": "Geen vervaldatum",
        "confirm_archive": "Weet u zeker dat u deze vacature wilt archiveren? U kunt er dan geen nieuwe links meer voor uitgeven.",
        "headers": {
            "title": "Vacature",
            "scenario": "Scenario",
            "status": "Status",
            "expires_at": "Vervalt op",
            "actions": "Acties"
        },
        "status": {
            "draft": "Concept",
            "active": "Actief",
            "archived": "Gearchiveerd"
        },
        "dialog": {
            "title_label": "Titel",
            "scenario_label": "Interviewscenario",
            "scenario_placeholder": "Kies een scenario voor het AI-interview",
            "scenario_hint": "Alleen scenario's die geschikt zijn voor een sessie vs AI worden getoond",
            "status_label": "Status",
            "expires_label": "Vervalt op",
            "expires_hint": "Leeg = geen vervaldatum",
            "save": "Opslaan",
            "cancel": "Annuleren"
        },
        "messages": {
            "created": "Vacature aangemaakt",
            "updated": "Vacature bijgewerkt",
            "archived": "Vacature gearchiveerd",
            "revoked": "Link ingetrokken",
            "attempt_granted": "Kandidaat heeft een extra poging gekregen",
            "copied": "Link gekopieerd",
            "error": "Er is iets misgegaan"
        },
        "candidates": {
            "title": "Kandidaten",
            "empty": "Voor deze vacature zijn nog geen links uitgegeven",
            "load_error": "De lijst met kandidaten kon niet worden geladen",
            "issue": "Link uitgeven",
            "import": "Importeren uit bestand",
            "expired": "Verlopen",
            "no_games": "Interview nog niet gestart",
            "attempts": "{used} van {allowed}",
            "revoke": "Link intrekken",
            "extra_attempt": "Extra poging geven",
            "open_result": "Interviewresultaat openen",
            "confirm_revoke": "Weet u zeker dat u de link van deze kandidaat wilt intrekken? De toegang vervalt direct, ook tot een lopend interview.",
            "confirm_extra_attempt": "Weet u zeker dat u deze kandidaat een extra poging wilt geven?",
            "headers": {
                "candidate": "Kandidaat",
                "link_status": "Link",
                "invite": "Uitnodiging",
                "game_status": "Interview",
                "attempts": "Pogingen",
                "expires_at": "Link vervalt op",
                "actions": "Acties"
            },
            "link_status": {
                "created": "Uitgegeven",
                "opened": "Geopend",
                "in_progress": "Interview loopt",
                "completed": "Interview afgerond",
                "revoked": "Ingetrokken"
            },
            "invite_status": {
                "not_sent": "Niet verzonden",
                "queued": "In wachtrij",
                "sent": "Verzonden",
                "failed": "Verzenden mislukt"
            },
            "invite_sent_at": "Door de mailservice geaccepteerd op {date}",
            "invite_failure": {
                "rejected": "De mailservice heeft de e-mail geweigerd — stuur de link zelf naar de kandidaat",
                "transport": "Verzenden mislukt — stuur de link zelf naar de kandidaat",
                "revoked": "De link is ingetrokken",
                "sending_disabled": "Het verzenden van e-mails is uitgeschakeld",
                "blocked": "Het adres staat in de blokkeerlijst — stuur de link zelf naar de kandidaat"
            }
        },
        "issue_dialog": {
            "title": "Persoonlijke link uitgeven",
            "name": "Voornaam",
            "last_name": "Achternaam",
            "email": "E-mail",
            "phone": "Telefoon",
            "attempts": "Aantal pogingen",
            "expires_at": "Link vervalt op",
            "expires_hint": "Leeg = vervaldatum van de vacature wordt gebruikt",
            "submit": "Link uitgeven",
            "close": "Sluiten",
            "result_title": "Link uitgegeven",
            "warning": "Kopieer de link nu — hij wordt maar één keer getoond. Er wordt alleen een hash opgeslagen, dus de link kan niet worden hersteld: een kwijtgeraakte link moet u intrekken en opnieuw uitgeven.",
            "copy": "Kopiëren",
            "copied": "Gekopieerd",
            "send_invite": "Uitnodiging sturen naar {email}",
            "send_invite_no_email": "Uitnodiging per e-mail sturen",
            "send_invite_blocked": "Dit adres staat in de blokkeerlijst — de e-mail wordt niet verzonden",
            "invite_queued": "Uitnodiging voor {email} staat in de wachtrij",
            "invite_blocked": "Uitnodiging niet verzonden: {email} staat in de blokkeerlijst. Stuur de link zelf naar de kandidaat"
        },
        "import_dialog": {
            "title": "Kandidaten importeren",
            "subtitle": "Elke rij in het bestand wordt één kandidaat en één persoonlijke link.",
            "file": "Bestand met kandidatenlijst",
            "columns": "Kolommen: Voornaam, Achternaam, E-mail, Telefoon",
            "limits": "xlsx of CSV met ';', max. 200 rijen en 10 MB",
            "size_error": "Het bestand is groter dan 10 MB",
            "download_example": "Sjabloon downloaden",
            "note_title": "De links zijn alleen zichtbaar in het gedownloade bestand",
            "note_text": "Het bestand wordt gedownload zodra het importeren is voltooid. Er wordt alleen de hash van de links opgeslagen — een tweede export is niet mogelijk, dus bewaar het bestand goed.",
            "submit": "Importeren",
            "cancel": "Annuleren",
            "result_title": "Links uitgegeven",
            "result": "Aantal uitgegeven links: {count}. Het bestand is gedownload.",
            "invites_blocked": "Uitnodigingen niet verzonden: {count}. Deze adressen staan in de blokkeerlijst — stuur de links zelf naar deze kandidaten.",
            "saved_title": "Bewaar het gedownloade bestand",
            "saved_text": "Dit is de enige kopie van deze links: de database bevat alleen de hash ervan. Een kwijtgeraakte link kan alleen worden ingetrokken en opnieuw uitgegeven.",
            "download_again": "Bestand opnieuw downloaden",
            "errors_title": "Afgewezen rijen",
            "error_row": "Rij {row}: {error}",
            "errors_truncated": "…en nog {count} afgewezen rijen. Hierboven staan de eerste 50.",
            "send_invites": "Uitnodigingen per e-mail naar de kandidaten sturen",
            "send_invites_hint": "Kandidaten zonder e-mailadres krijgen geen uitnodiging"
        }
    },
    "ai-reports": "AI-rapporten",
    "ai-reports-page": {
        "title": "AI-rapporten",
        "subtitle": "Beschrijf het rapport in eigen woorden – wij stellen de specificatie op, tonen een voorbeeld en exporteren naar Excel.",
        "status": {
            "draft": "Concept",
            "pending": "Wordt opgebouwd",
            "ready": "Gereed",
            "failed": "Mislukt"
        },
        "list": {
            "title": "Mijn rapporten",
            "new": "Nieuw rapport",
            "empty": "Nog geen rapporten. Klik op “Nieuw rapport” en beschrijf wat u wilt zien.",
            "untitled": "Zonder titel",
            "delete": "Rapport verwijderen",
            "delete_confirm": "Dit rapport samen met het gegenereerde bestand verwijderen?",
            "deleted": "Rapport verwijderd"
        },
        "dialog": {
            "title": "Dialoog",
            "open_dictionary": "Gegevensoverzicht",
            "placeholder": "Bijvoorbeeld: hoeveel spellen heeft elke afdeling afgelopen kwartaal gedaan",
            "send": "Verzenden",
            "empty_title": "Wat moet het rapport tonen?",
            "empty_text": "Schrijf het in gewone woorden: welke gegevens, voor welke periode en in welke uitsplitsing. Ontbreekt er iets, dan vraag ik ernaar.",
            "examples_title": "Bijvoorbeeld:",
            "examples": {
                "e1": "Hoeveel spellen heeft elke afdeling afgelopen kwartaal gedaan",
                "e2": "Gemiddelde competentiescore in de verkoopafdeling voor 2026",
                "e3": "Medewerkers die langer dan een maand niet hebben gespeeld",
                "e4": "Kandidaten per vacature en de linkstatus van de afgelopen 30 dagen"
            },
            "thinking": "Rapport wordt opgebouwd…",
            "waiting_hint": "Het antwoord verschijnt hier vanzelf — de pagina hoeft niet te worden vernieuwd.",
            "retry": "Opnieuw proberen",
            "dismiss": "Verbergen",
            "spec_ready": "Het rapport is opgesteld – bekijk het voorbeeld hieronder en genereer het bestand.",
            "stuck_title": "Het lijkt erop dat we in cirkels ronddraaien",
            "stuck_text": "Bekijk het gegevensoverzicht en herformuleer het verzoek met die bewoordingen – dat gaat sneller dan nog een verduidelijkende vraag beantwoorden.",
            "rejected_title": "Dit rapport kan nog niet worden gegenereerd",
            "reason": {
                "no_such_measure": "Deze meting bestaat niet in onze gegevens. Bekijk de lijst met metingen in het overzicht.",
                "no_such_field": "Dit veld bestaat niet in onze gegevens. Bekijk de lijst met velden in het overzicht.",
                "cross_dataset": "Het verzoek vereist gegevens uit twee gegevenssets tegelijk. Splits het op in twee rapporten.",
                "window_function": "Aandelen van het totaal, ranglijstposities en vergelijking met de vorige periode worden nog niet ondersteund.",
                "other": "Het verzoek gaat verder dan de beschikbare gegevens. Bekijk het overzicht en probeer een andere formulering."
            },
            "usage": {
                "employees": "geen medewerkers | {n} medewerker | {n} medewerkers",
                "games": "geen spellen | {n} spel | {n} spellen",
                "scenarios": "geen scenario's | {n} scenario | {n} scenario's",
                "evaluations": "geen beoordelingen | {n} beoordeling | {n} beoordelingen",
                "candidates": "geen kandidaten | {n} kandidaat | {n} kandidaten"
            },
            "option_created_at": "toegevoegd op {date}"
        },
        "preview": {
            "title": "Voorbeeld",
            "no_report": "Kies links een rapport of start een nieuw rapport.",
            "no_spec": "Beschrijf het rapport in de dialoog – het voorbeeld verschijnt zodra het verzoek is begrepen.",
            "spec_title": "Wat het rapport zal bevatten",
            "rows_hint": "De eerste {count} rijen worden getoond",
            "total": "Totaal aantal rijen: {count}",
            "zero_rows": "Dit verzoek levert geen enkele rij op. Verbreed de periode of verwijder filters – het heeft geen zin een leeg bestand te genereren.",
            "zero_rows_hint": "Controleer de filterwaarden – hiervoor zijn mogelijk geen gegevens",
            "duplicate_rows": "Sommige rijen in het voorbeeld zijn identiek: de gekozen kolommen onderscheiden de records van deze gegevensset niet. Controleer wat één rij hier werkelijk betekent — mogelijk ontbreekt een onderscheidende kolom.",
            "too_many_rows": "Het rapport bevat {count} rijen, het maximum is {max}. Beperk de periode of voeg filters toe: boven de grens wordt het bestand helemaal niet gegenereerd in plaats van afgekapt.",
            "generate": "Bestand genereren",
            "regenerate": "Opnieuw genereren",
            "queued": "Het bestand wordt opgebouwd – de kaart werkt zichzelf bij zodra het gereed is.",
            "failed": "Het rapport kon niet worden gegenereerd",
            "download": ".xlsx downloaden",
            "downloads": "Downloads: {count}",
            "ttl_warning": "Het bestand wordt {days} dagen bewaard en daarna verwijderd – download het meteen.",
            "expires_at": "Beschikbaar tot {date}",
            "expired": "Het bestand is verwijderd na afloop van de bewaartermijn – genereer het rapport opnieuw."
        },
        "spec": {
            "dataset": "Gegevens",
            "columns": "Kolommen",
            "measures": "Metingen",
            "group_by": "Uitsplitsing",
            "period": "Periode",
            "period_value": "{field}: van {from} tot {to}",
            "period_all": "Volledige beschikbare periode",
            "filters": "Filters",
            "having": "Voorwaarden voor metingen",
            "sort": "Sortering",
            "limit": "Rijlimiet",
            "limit_value": "eerste {count} rijen",
            "granularity": {
                "year": "per jaar",
                "quarter": "per kwartaal",
                "month": "per maand",
                "week": "per week",
                "day": "per dag",
                "dow": "per weekdag"
            },
            "dir": {
                "asc": "oplopend",
                "desc": "aflopend"
            },
            "filter": {
                "equals": "{field} — {value}",
                "not_equals": "{field} — niet {value}",
                "in": "{field} — een van: {value}",
                "not_in": "{field} — behalve: {value}",
                "gt": "{field} groter dan {value}",
                "gte": "{field} ten minste {value}",
                "lt": "{field} kleiner dan {value}",
                "lte": "{field} ten hoogste {value}",
                "contains": "{field} bevat “{value}”",
                "between": "{field} — van {from} tot {to}",
                "is_null": "{field} niet ingevuld",
                "is_not_null": "{field} ingevuld"
            }
        },
        "value": {
            "yes": "Ja",
            "no": "Nee"
        },
        "dictionary": {
            "title": "Gegevensoverzicht",
            "subtitle": "Alles wat in een rapport kan worden opgenomen. De lijst is live: het is dezelfde lijst waaruit de specificatie wordt opgebouwd.",
            "fields": "Velden",
            "measures": "Metingen",
            "values": "Waarden",
            "show_values": "Waarden van uw organisatie tonen",
            "hide_values": "Waarden verbergen",
            "values_error": "De waarden konden niet worden geladen – probeer het opnieuw.",
            "values_empty": "Uw organisatie heeft nog geen waarden voor dit veld.",
            "limits": {
                "title": "Wat een rapport niet kan",
                "pivot": "Een draaitabel met een kolom per deelnemer of per vraag wordt niet gebouwd. Vraag in plaats daarvan de lange vorm aan: één rij per combinatie van deelnemer en vraag.",
                "window": "Het rapport berekent geen verandering van maand tot maand, aandeel van het totaal, positie in een ranglijst of “de top drie per afdeling”. Neem de uitsplitsing per maand en werk de rest uit in Excel.",
                "missing": "Wat het systeem niet bewaart, verschijnt niet in een rapport: salarissen, NPS en andere gegevens uit andere systemen komen onder geen enkele naam tevoorschijn."
            },
            "empty": "Het overzicht is leeg – neem contact op met uw beheerder.",
            "close": "Sluiten"
        },
        "errors": {
            "generic": "Er is iets misgegaan. Probeer het opnieuw.",
            "detail": "Niet begrepen: {value}",
            "rate_limit": "Te veel verzoeken. Wacht een minuut en probeer het opnieuw.",
            "download": "Het bestand kon niet worden gedownload.",
            "turn_failed": "Het antwoord kon niet worden opgehaald. Verstuur uw vraag opnieuw.",
            "turn_stuck_in_queue": "De vraag is nooit verwerkt — hij heeft te lang in de wachtrij gestaan. Verstuur hem opnieuw.",
            "unknown_resolution": "Deze optie is verouderd — het rapport is intussen gewijzigd. Open het opnieuw en verduidelijk uw vraag."
        }
    },
    "externalLaunch": {
        "document_title": "Oefensessie",
        "intro": {
            "title": "Oefengesprek",
            "lead": "U gaat zo praten met een virtuele gesprekspartner. Het gesprek wordt opgenomen en beoordeeld, en het resultaat gaat terug naar uw leerplatform.",
            "requirements_title": "Wat u nodig heeft",
            "requirement_mic": "Een werkende microfoon, bij voorkeur een headset",
            "requirement_camera": "Een camera is niet verplicht, maar het gesprek verloopt natuurlijker als u hem aanzet",
            "requirement_browser": "Een computer met een actuele versie van Chrome, Edge of Safari",
            "requirement_network": "Een stabiele internetverbinding en een rustige plek waar u niet gestoord wordt",
            "start": "Starten"
        },
        "relaunch_hint": "Ga terug naar uw leerplatform en open het materiaal opnieuw.",
        "saving": "Resultaat wordt opgeslagen…",
        "review": {
            "document_title": "Sessiebeoordeling",
            "attempt": "Poging {number}",
            "result": {
                "passed": "Geslaagd",
                "failed": "Niet geslaagd",
                "pending": "Nog niet beoordeeld"
            },
            "score_of_100": "{score} van de 100",
            "threshold": "Slaaggrens: {threshold}",
            "skills_title": "Vaardigheden en aanbevelingen",
            "skills_empty": "Voor deze poging is er nog geen feedback per vaardigheid.",
            "comments_title": "Opmerkingen bij de opname",
            "comments_empty": "Er zijn geen opmerkingen bij deze opname.",
            "loading": "Beoordeling wordt geladen",
            "error": {
                "not_found": {
                    "title": "De link werkt niet",
                    "text": "De beoordeling is niet meer beschikbaar: de link is verlopen of de poging is ingetrokken."
                },
                "expired": {
                    "title": "De pagina is verlopen",
                    "text": "Open de beoordeling opnieuw via de link in uw leerplatform."
                },
                "generic": {
                    "title": "De beoordeling kan niet worden weergegeven",
                    "text": "Er is iets misgegaan aan onze kant. Probeer de link opnieuw te openen."
                }
            }
        },
        "terminal": {
            "finished": {
                "title": "Bedankt!",
                "text": "Het gesprek is afgelopen. Het resultaat verschijnt in uw leerplatform zodra de beoordeling klaar is. U kunt deze pagina nu sluiten."
            },
            "aborted": {
                "title": "Het gesprek is niet gestart",
                "text": "Er is iets misgegaan voordat het gesprek begon."
            },
            "token_expired": {
                "title": "De sessie is verlopen",
                "text": "De toegang tot dit gesprek is niet meer geldig."
            },
            "not_found": {
                "title": "De link werkt niet",
                "text": "Het adres bevat mogelijk een typefout, of de link is niet meer geldig."
            },
            "rate_limited": {
                "title": "Te veel pogingen",
                "text": "Wacht een minuut voordat u het opnieuw probeert."
            },
            "generic": {
                "title": "Nu starten is niet mogelijk",
                "text": "Er is iets misgegaan aan onze kant."
            }
        },
        "refusal": {
            "publication_disabled": {
                "title": "Het materiaal is gesloten",
                "text": "Dit materiaal is niet meer beschikbaar om te oefenen."
            },
            "publication_draft": {
                "title": "Het materiaal is nog niet gepubliceerd",
                "text": "Oefenen met dit materiaal is nog niet geopend."
            },
            "publication_expired": {
                "title": "Het materiaal is verlopen",
                "text": "De periode waarin met dit materiaal kon worden geoefend, is voorbij."
            },
            "feature_disabled": {
                "title": "Het materiaal is gesloten",
                "text": "Oefenen vanuit het leerplatform is uitgeschakeld voor uw organisatie."
            },
            "connection_disabled": {
                "title": "Het materiaal is gesloten",
                "text": "De verbinding met uw leerplatform is uitgeschakeld. Neem contact op met degene die u de cursus heeft toegewezen."
            },
            "launch_limit_reached": {
                "title": "De limiet is bereikt",
                "text": "Voor dit materiaal is het maximale aantal gesprekken al gevoerd."
            },
            "daily_budget_exhausted": {
                "title": "Genoeg voor vandaag",
                "text": "U heeft het aantal gesprekken bereikt dat per dag is toegestaan. Probeer het morgen opnieuw."
            },
            "attempts_exhausted": {
                "title": "Geen pogingen meer over",
                "text": "U heeft alle pogingen gebruikt die voor dit materiaal zijn toegestaan."
            },
            "quota_exhausted": {
                "title": "Nu starten is niet mogelijk",
                "text": "Uw organisatie heeft geen gesprekken meer over. Neem contact op met degene die u de cursus heeft toegewezen."
            },
            "user_limit_reached": {
                "title": "Nu starten is niet mogelijk",
                "text": "Uw organisatie heeft geen vrije plekken meer over. Neem contact op met degene die u de cursus heeft toegewezen."
            },
            "scenario_unavailable": {
                "title": "Het materiaal is niet beschikbaar",
                "text": "Het gesprek achter dit materiaal bestaat niet meer."
            },
            "assignment_check_unavailable": {
                "title": "Nu starten is niet mogelijk",
                "text": "We konden niet bevestigen dat dit materiaal aan u is toegewezen. Neem contact op met degene die u de cursus heeft toegewezen."
            },
            "code_invalid": {
                "title": "De link is niet meer geldig",
                "text": "Deze link is al gebruikt of de tijd is verstreken."
            },
            "channel_verification_failed": {
                "title": "Het leerplatform heeft niet gereageerd",
                "text": "We konden het verzoek niet bevestigen bij uw leerplatform."
            },
            "external_system_unavailable": {
                "title": "Het leerplatform reageert niet",
                "text": "We konden uw cursustoewijzing niet controleren in het leerplatform. Probeer het over enkele minuten opnieuw."
            },
            "user_not_found": {
                "title": "We konden u niet identificeren",
                "text": "Er is hier nog geen account voor u, en uw organisatie maakt deze niet automatisch aan. Neem contact op met degene die u de cursus heeft toegewezen."
            },
            "user_unavailable": {
                "title": "Uw account is uitgeschakeld",
                "text": "Neem contact op met degene die u de cursus heeft toegewezen."
            },
            "user_deleted": {
                "title": "Uw account is verwijderd",
                "text": "Neem contact op met degene die u de cursus heeft toegewezen."
            },
            "email_taken_linking_disabled": {
                "title": "We konden u niet identificeren",
                "text": "Uw e-mailadres behoort hier al tot een ander account. Neem contact op met degene die u de cursus heeft toegewezen."
            },
            "service_role_not_allowed": {
                "title": "Met dit account kan niet worden geoefend",
                "text": "Beheerdersaccounts nemen niet deel aan oefengesprekken. Gebruik uw eigen cursistaccount."
            },
            "unverified_request": {
                "title": "We konden het verzoek niet bevestigen",
                "text": "Uw leerplatform heeft niet bevestigd dat u dit gesprek heeft gestart."
            }
        },
        "manage": {
            "nav": {
                "group": "Externe start",
                "publications": "Publicaties",
                "connections": "LMS-verbindingen"
            },
            "messages": {
                "error": "Er is iets misgegaan. Probeer het opnieuw.",
                "load_error": "De gegevens konden niet worden geladen."
            },
            "connections": {
                "title": "LMS-verbindingen",
                "subtitle": "Accounts van leerplatforms van waaruit deze organisatie oefengesprekken start.",
                "create": "Verbinding toevoegen",
                "edit": "Bewerken",
                "set_credentials": "Inloggegevens instellen",
                "empty": "Nog geen verbindingen.",
                "secret_missing": "Niet ingesteld",
                "no_expiry": "Verloopt niet",
                "headers": {
                    "account": "Account",
                    "base_url": "Adres",
                    "client_id": "Client-ID",
                    "secret": "Secret",
                    "status": "Status",
                    "expires_at": "Inloggegevens verlopen",
                    "actions": " "
                },
                "status": {
                    "no_credentials": "Geen inloggegevens",
                    "active": "Actief",
                    "expired": "Inloggegevens verlopen",
                    "disabled": "Uitgeschakeld"
                },
                "lms": {
                    "ispring": "iSpring Learn"
                },
                "dialog": {
                    "create_title": "Nieuwe verbinding",
                    "edit_title": "Verbinding",
                    "immutable_hint": "Het leerplatform en het account kunnen niet worden gewijzigd: ze bepalen de identiteitsruimte van de cursisten. Een ander account is een nieuwe verbinding.",
                    "lms_label": "Leerplatform",
                    "account_key_label": "Account",
                    "account_key_hint": "De account-id in het leerplatform.",
                    "base_url_label": "iSpring REST API-adres",
                    "base_url_hint": "Bijvoorbeeld https://api-learn.ispringlearn.ru. Dit is niet het adres van uw bedrijfsportaal: het secret wordt hiernaartoe verzonden.",
                    "base_url_https": "Het adres moet beginnen met https://",
                    "enabled_label": "Verbinding is ingeschakeld",
                    "enabled_hint": "Een verbinding wordt nooit verwijderd — ze wordt uitgeschakeld. Publicaties en starts blijven in de lijsten staan, maar nieuwe starts worden geweigerd en resultaten gaan niet meer naar het leerplatform.",
                    "credentials_optional": "Inloggegevens zijn optioneel. Zonder inloggegevens werkt de verbinding in beperkte modus.",
                    "client_id_label": "Client-ID",
                    "secret_label": "Secret",
                    "secret_hint": "Wordt versleuteld opgeslagen. Het kan nooit worden teruggelezen — alleen de laatste vier tekens worden getoond.",
                    "expires_at_label": "Inloggegevens verlopen",
                    "expires_at_hint": "Laat leeg als de inloggegevens niet verlopen."
                },
                "credentials_dialog": {
                    "title": "Inloggegevens",
                    "lead": "Het nieuwe secret vervangt het vorige. De verbinding behoudt haar identificatie, en de links en starts van cursisten blijven ongewijzigd.",
                    "secret_hint": "Het vorige secret is niet meer nodig en kan niet worden teruggelezen."
                },
                "messages": {
                    "saved": "Verbinding opgeslagen",
                    "credentials_saved": "Inloggegevens opgeslagen"
                }
            },
            "publications": {
                "title": "Publicaties",
                "subtitle": "Scenario's die zijn opengesteld om te starten vanuit een leerplatform.",
                "create": "Nieuwe publicatie",
                "edit": "Bewerken",
                "enable": "Inschakelen",
                "disable": "Uitschakelen",
                "open_journal": "Logboek",
                "download_package": "Pakket downloaden",
                "empty": "Nog geen publicaties.",
                "no_connections": "Er is nog geen verbinding met een leerplatform. Een platformbeheerder richt deze in.",
                "no_expiry": "Geen vervaldatum",
                "attempts_unlimited": "Onbeperkt",
                "immutable_hint": "Verbinding, scenario en afleveringskanaal kunnen niet worden gewijzigd: ze zijn ingebouwd in het pakket dat al naar het leerplatform is geüpload. Al het andere geldt zonder dat het pakket opnieuw hoeft te worden opgebouwd.",
                "headers": {
                    "scenario": "Scenario",
                    "connection": "Verbinding",
                    "channel": "Kanaal",
                    "status": "Status",
                    "settings": "Instellingen",
                    "expires_at": "Verloopt",
                    "actions": " "
                },
                "summary": {
                    "attempts": "Pogingen: {value}",
                    "threshold": "Slaaggrens: {value}"
                },
                "status": {
                    "draft": "Concept",
                    "active": "Actief",
                    "disabled": "Uitgeschakeld"
                },
                "channel": {
                    "scorm_1_2": "SCORM 1.2",
                    "scorm_2004": "SCORM 2004"
                },
                "result_mode": {
                    "status_only": "Alleen status",
                    "status_and_score": "Status en score",
                    "status_score_and_review": "Status, score en een link naar de beoordeling"
                },
                "warnings": {
                    "limited_mode": "Beperkte modus: de score en de uitkomst verschijnen niet in het leerplatform, en de toewijzingscontrole wordt niet uitgevoerd.",
                    "connection_disabled": "De verbinding is uitgeschakeld: starts via deze publicatie worden helemaal niet geaccepteerd totdat een beheerder de verbinding weer inschakelt.",
                    "assignment_check_off": "Als de schakelaar uit staat, wordt een nieuwe cursustoewijzing niet gedetecteerd.",
                    "no_course_binding": "De publicatie is niet gekoppeld aan een cursus — de score bereikt het leerplatform niet."
                },
                "dialog": {
                    "connection_label": "Verbinding",
                    "scenario_label": "Scenario",
                    "channel_label": "Afleveringskanaal",
                    "channel_hint": "Ingebouwd in het pakket en daarna niet meer te wijzigen.",
                    "status_label": "Status",
                    "status_hint": "Een publicatie wordt nooit verwijderd — ze wordt uitgeschakeld. Daarna worden nieuwe starts geweigerd en nog niet verzonden resultaten geannuleerd.",
                    "settings_section": "Instellingen voor pogingen",
                    "attempts_label": "Pogingen per cursist",
                    "attempts_unlimited": "Zonder limiet",
                    "daily_budget_label": "Starts per dag per cursist",
                    "daily_budget_hint": "Beschermt het tegoed: elk gestart gesprek wordt in rekening gebracht en nooit terugbetaald.",
                    "result_mode_label": "Wat teruggaat naar het leerplatform",
                    "pass_threshold_label": "Slaaggrens, 0–100",
                    "result_wait_label": "Wachttijd op de beoordeling, uren",
                    "result_wait_hint": "Daarna meldt de start “geen resultaat”.",
                    "launch_limit_label": "Totale startlimiet",
                    "launch_limit_hint": "Laat leeg voor geen limiet.",
                    "assignment_check_label": "Toewijzing in het leerplatform controleren",
                    "binding_section": "Koppeling in het leerplatform",
                    "external_course_label": "Cursus-ID",
                    "external_item_label": "Item-ID",
                    "expires_label": "Publicatie verloopt",
                    "expires_hint": "Laat leeg als de publicatie niet verloopt."
                },
                "key_dialog": {
                    "title": "De publicatie is aangemaakt",
                    "warning": "De sleutel wordt eenmalig en alleen hier getoond. Hij kan nergens worden teruggelezen — kopieer hem nu en zet hem in de pakketinstellingen. Bent u hem kwijt, dan moet u een nieuwe publicatie aanmaken.",
                    "key_label": "Publicatiesleutel",
                    "copied": "Gekopieerd",
                    "package_hint": "De sleutel zit al in het pakket, dus er is niets om ergens te plakken. Download het pakket en upload het naar het leerplatform. U kunt het op elk moment opnieuw downloaden op de pagina Publicaties."
                },
                "messages": {
                    "saved": "Publicatie opgeslagen",
                    "enabled": "Publicatie ingeschakeld",
                    "disabled": "Publicatie uitgeschakeld",
                    "download_failed": "Het pakket kon niet worden gedownload. Vernieuw de pagina en probeer het opnieuw."
                }
            },
            "journal": {
                "title": "Startlogboek",
                "unknown_scenario": "Scenario niet beschikbaar",
                "back": "Naar publicaties",
                "revoke": "Poging intrekken",
                "revoke_confirm": "Deze poging intrekken? De cursist verliest de toegang tot het gesprek, en nog niet verzonden afleveringen worden geannuleerd.",
                "retry_delivery": "Opnieuw proberen",
                "empty_launches": "Nog geen starts.",
                "empty_events": "Nog geen gebeurtenissen.",
                "no_deliveries": "Voor deze poging zijn er geen afleveringen.",
                "not_held_quota_charged": "Niet plaatsgevonden, tegoed belast",
                "relaunches": "herstarts: {value}",
                "last_launch": "laatste start: {value}",
                "result_deadline": "Wachten op de beoordeling tot {value}",
                "learner_contacts": "Adres verzonden door het leerplatform: {email}. Gestart vanaf: {ip}",
                "score_passed": "{value} — geslaagd",
                "score_failed": "{value} — niet geslaagd",
                "tabs": {
                    "launches": "Pogingen",
                    "events": "Gebeurtenissen"
                },
                "headers": {
                    "learner": "Cursist",
                    "user": "Account",
                    "attempt": "Poging",
                    "status": "Status",
                    "game": "Gesprek",
                    "started_at": "Gestart",
                    "actions": " ",
                    "event_type": "Gebeurtenis",
                    "refusal": "Reden",
                    "request_proof": "Verzoekbewijs",
                    "ip": "Adres",
                    "user_agent": "Client",
                    "happened_at": "Wanneer"
                },
                "launch_status": {
                    "created": "Link uitgegeven",
                    "started": "Bezig",
                    "not_held": "Niet plaatsgevonden",
                    "awaiting_result": "Wacht op de beoordeling",
                    "result_ready": "Resultaat afgeleverd",
                    "evaluation_failed": "Geen beoordeling",
                    "result_timed_out": "Wachttijd verstreken",
                    "assignment_changed": "Toewijzing gewijzigd",
                    "revoked": "Ingetrokken"
                },
                "delivery": {
                    "version": "Versie",
                    "status": "Status",
                    "outcome": "Uitkomst",
                    "result": "Resultaat",
                    "score": "Score",
                    "attempts": "Pogingen",
                    "last_attempt": "Laatste poging",
                    "external_state": "Status in het leerplatform"
                },
                "delivery_status": {
                    "pending": "In wachtrij",
                    "in_progress": "Wordt verzonden",
                    "done": "Voltooid",
                    "needs_attention": "Vereist aandacht"
                },
                "delivery_outcome": {
                    "accepted": "Geaccepteerd",
                    "confirmed": "Bevestigd",
                    "rejected_by_external": "Afgewezen",
                    "retry": "Opnieuw gepland",
                    "cancelled": "Geannuleerd",
                    "assignment_changed": "Toewijzing gewijzigd"
                },
                "result": {
                    "passed": "Geslaagd",
                    "failed": "Niet geslaagd",
                    "not_held": "Niet plaatsgevonden",
                    "no_result": "Geen resultaat"
                },
                "refusal": {
                    "publication_disabled": "Publicatie uitgeschakeld",
                    "publication_draft": "Publicatie is nog concept",
                    "publication_expired": "Publicatie verlopen",
                    "feature_disabled": "Externe start uitgeschakeld",
                    "connection_disabled": "Verbinding uitgeschakeld",
                    "launch_limit_reached": "Startlimiet bereikt",
                    "daily_budget_exhausted": "Dagbudget uitgeput",
                    "attempts_exhausted": "Pogingen uitgeput",
                    "quota_exhausted": "Tegoed van de organisatie uitgeput",
                    "user_limit_reached": "Geen vrije plekken meer",
                    "scenario_unavailable": "Scenario niet beschikbaar",
                    "assignment_check_unavailable": "Toewijzingscontrole niet beschikbaar",
                    "code_invalid": "Link al gebruikt of verlopen",
                    "channel_verification_failed": "Leerplatform heeft verzoek niet bevestigd",
                    "external_system_unavailable": "Leerplatform heeft niet gereageerd op de toewijzingscontrole",
                    "user_not_found": "Geen account voor deze cursist",
                    "user_unavailable": "Account van de cursist uitgeschakeld",
                    "user_deleted": "Account van de cursist verwijderd",
                    "email_taken_linking_disabled": "E-mail behoort tot een ander account",
                    "service_role_not_allowed": "Service-account kan niet oefenen",
                    "unverified_request": "Verzoek niet bevestigd"
                },
                "event_type": {
                    "launch_refused": "Start geweigerd",
                    "exchange_refused": "Link geweigerd",
                    "exchange_succeeded": "Link gebruikt"
                },
                "request_proof": {
                    "unverified": "Niet bevestigd",
                    "assignment_verified": "Toewijzing bevestigd"
                },
                "messages": {
                    "retry_queued": "Opnieuw ingepland",
                    "revoked": "Poging ingetrokken"
                }
            }
        }
    },
    "voiceSession": {
        "mode": {
            "training": "Training",
            "interview": "Interview"
        },
        "load": {
            "loading": "Sessie wordt geladen…",
            "failed": "De sessie kon niet worden geladen. Controleer uw verbinding en probeer het opnieuw.",
            "scenarioFailed": "Het scenario is niet geladen",
            "scenarioRetry": "Opnieuw proberen"
        },
        "leave": {
            "confirm": "Het gesprek is nog bezig. Als u de pagina verlaat, stopt het niet en blijft de tijd doorlopen. Pagina verlaten?",
            "confirmEnd": "Het gesprek is nog bezig. Als u weggaat, wordt het beëindigd en beoordeeld op basis van wat u heeft behandeld. Weggaan?"
        },
        "elsewhere": {
            "interviewTitle": "Het interview is open in een ander tabblad",
            "interviewText": "Het interview loopt door in een ander tabblad of op een ander apparaat. Ga daar verder — u kunt dit tabblad sluiten.",
            "conversationTitle": "Het gesprek is open in een ander tabblad",
            "conversationText": "Het gesprek loopt door in een ander tabblad of op een ander apparaat. Ga daar verder — u kunt dit tabblad sluiten."
        },
        "prep": {
            "header": {
                "backToSessions": "Naar sessies",
                "themeToggleAriaLabel": "Thema wisselen"
            },
            "scenario": {
                "sectionLabel": "Scenario",
                "competenceLabel": "Beoordeelde competentie",
                "gameNumber": "Sessie #{number}",
                "duration": "{minutes} min",
                "readFull": "Volledig lezen",
                "generalLabel": "Algemene informatie",
                "playerLabel": "Informatie voor u"
            },
            "selfCamera": {
                "previewLabel": "Voorbeeld van uw camera",
                "off": "Camera is uit"
            },
            "notes": {
                "empty": "Leeg"
            },
            "start": {
                "button": "Sessie starten",
                "interviewButton": "Interview starten",
                "resumeButton": "Terug naar het gesprek",
                "resumeHint": "Het gesprek loopt al — de tijd blijft doorlopen."
            }
        },
        "equipment": {
            "status": {
                "checking": "Apparatuur controleren",
                "waiting": "Wachten op toestemming",
                "denied": "Toegang geweigerd",
                "busy": "Apparaat bezet",
                "noCamera": "Geen camera",
                "missing": "Geen microfoon",
                "dismissed": "Geen toegang gegeven",
                "ready": "Apparatuur gereed"
            },
            "checking": {
                "title": "Uw microfoon en camera worden gecontroleerd…"
            },
            "waiting": {
                "title": "Sta toegang tot de microfoon toe",
                "cameraTitle": "Sta toegang tot de camera toe",
                "description": "Het toestemmingsvenster van de browser staat al open. Zonder microfoon kan het gesprek niet beginnen."
            },
            "denied": {
                "title": "De browser blokkeert de microfoon",
                "cameraTitle": "De browser blokkeert de camera",
                "description": "Uw browser heeft de blokkering onthouden. Sta microfoontoegang toe in de sitegegevens en herlaad de pagina.",
                "cameraDescription": "Uw browser heeft de blokkering onthouden. Sta cameratoegang toe in de sitegegevens en herlaad de pagina.",
                "showInstructions": "Laat zien hoe",
                "hideInstructions": "Verbergen",
                "chromeEdge": {
                    "browser": "Chrome en Edge",
                    "text": "Klik op het slotje links van de adresbalk, open «Sitegegevens», sta «Microfoon» toe en herlaad de pagina."
                },
                "safari": {
                    "browser": "Safari",
                    "text": "Open het Safari-menu → «Instellingen voor deze website», sta «Microfoon» toe en herlaad de pagina."
                },
                "firefox": {
                    "browser": "Firefox",
                    "text": "Klik op het microfoonpictogram in de adresbalk, hef de blokkering voor deze site op en herlaad de pagina."
                },
                "system": {
                    "title": "Uw systeem blokkeert de browser voor de microfoon",
                    "cameraTitle": "Uw systeem blokkeert de browser voor de camera",
                    "macos": "macOS: Systeeminstellingen → Privacy en beveiliging → Microfoon (of Camera) → schakel uw browser in en start deze opnieuw.",
                    "windows": "Windows: Instellingen → Privacy en beveiliging → Microfoon (of Camera) → sta toegang toe voor apps en uw browser, en klik dan op «Opnieuw proberen»."
                }
            },
            "busy": {
                "title": "De microfoon wordt gebruikt door een andere app",
                "cameraTitle": "De camera wordt gebruikt door een andere app",
                "description": "Meestal is dit een gesprek dat op de achtergrond is blijven lopen. Sluit het en klik op «Opnieuw proberen».",
                "retry": "Opnieuw proberen"
            },
            "noCamera": {
                "title": "Geen camera",
                "description": "U wordt gehoord, maar niet gezien.",
                "requiredByScenario": "Dit gesprek vereist een camera. Sluit er een aan om door te gaan."
            },
            "missing": {
                "title": "Geen microfoon gevonden",
                "description": "Sluit een microfoon aan en klik op «Opnieuw proberen». Zonder microfoon kan het gesprek niet beginnen."
            },
            "dismissed": {
                "title": "Geen toegang gegeven tot de microfoon",
                "cameraTitle": "Geen toegang gegeven tot de camera",
                "description": "Het browservenster is gesloten zonder antwoord. Klik op «Opnieuw proberen» en geef toegang."
            },
            "ready": {
                "title": "Apparatuur gereed"
            },
            "micLabel": "Microfoon",
            "cameraLabel": "Camera",
            "chooseMic": "Microfoon kiezen",
            "chooseCamera": "Camera kiezen",
            "micLevelHint": "Zeg iets",
            "speakerValue": "Luidspreker: {name}",
            "configure": "Instellen",
            "dialog": {
                "title": "Apparatuur",
                "lockedDuringConversation": "Apparaten kunnen tijdens het gesprek niet worden gewijzigd.",
                "micSelectLabel": "Microfoon",
                "cameraSelectLabel": "Camera",
                "speakerSelectLabel": "Luidspreker",
                "noCameraOption": "Geen camera",
                "record": "3 seconden opnemen",
                "recording": "Opname loopt…",
                "recordFailed": "Opnemen mislukt. Probeer het opnieuw.",
                "listen": "Afspelen",
                "playing": "Wordt afgespeeld…",
                "done": "Klaar",
                "closeAriaLabel": "Dialoog sluiten"
            },
            "unnamed": {
                "microphone": "Microfoon {number}",
                "camera": "Camera {number}",
                "speaker": "Luidspreker {number}"
            },
            "cameraWarmup": {
                "preview": "Camera wordt ingeschakeld",
                "title": "Microfoon gereed",
                "description": "De camera volgt zo — meestal binnen een seconde of twee.",
                "slowHint": "Camera gaat niet aan? Kies een andere via «Instellen»."
            }
        },
        "recording": {
            "videoAndAudio": "Het gesprek en de video worden opgenomen.",
            "audioOnly": "Het gesprek wordt opgenomen.",
            "accessSelfAndEvaluators": "De opname is beschikbaar voor u en voor wie uw werk beoordeelt.",
            "accessEvaluators": "De opname is beschikbaar voor wie uw werk beoordeelt."
        },
        "scenario": {
            "video": "Video van de scenarioauteur"
        },
        "notes": {
            "title": "Sessienotities",
            "placeholder": "Wat u wilt oefenen, formuleringen die u heeft voorbereid",
            "saving": "Opslaan…",
            "saved": "Opgeslagen",
            "saveError": "Opslaan mislukt",
            "visibility": "Notities zijn zichtbaar voor u en voor wie de sessie beoordeelt.",
            "unsupported": "Deze notities bevatten elementen die hier niet kunnen worden bewerkt. Ze blijven ongewijzigd bewaard."
        },
        "stage": {
            "agentState": {
                "speaking": "Spreekt",
                "listening": "Luistert",
                "thinking": "Denkt na"
            },
            "micOffWarning": "Microfoon staat uit — de ander kan u niet horen",
            "micOnAriaLabel": "Microfoon uitzetten",
            "micOffAriaLabel": "Microfoon aanzetten",
            "micOff": "Microfoon uit",
            "micOnAnnouncement": "Microfoon aan",
            "captionsLabel": "Ondertiteling",
            "captionsOnAriaLabel": "Ondertiteling verbergen",
            "captionsOffAriaLabel": "Ondertiteling tonen",
            "talkBalance": {
                "title": "Spreekbalans",
                "you": "U",
                "interlocutor": "Gesprekspartner"
            },
            "connectionQuality": {
                "excellent": "Uitstekende verbinding",
                "good": "Goede verbinding",
                "poor": "Zwakke verbinding",
                "unknown": "Verbindingskwaliteit onbekend"
            },
            "selfCameraLabel": "U",
            "timeWarning": {
                "lastMinute": "Nog één minuut — tijd om af te ronden",
                "finalSeconds": "15 seconden — maak uw gedachte af"
            },
            "timeUp": {
                "title": "Tijd is om",
                "text": "Het gesprek sluit automatisch en kan niet worden verlengd.",
                "closing": "Gesprek wordt afgesloten…"
            },
            "voiceOnly": "Alleen spraak — dit scenario heeft geen video",
            "interlocutorConnecting": {
                "title": "Gesprekspartner maakt verbinding",
                "hint": "Meestal 2–4 seconden"
            },
            "layout": {
                "label": "Naast elkaar",
                "sideTitle": "Naast elkaar plaatsen",
                "focusTitle": "Gesprekspartner vergroten"
            }
        },
        "panels": {
            "scenario": "Scenario",
            "transcript": "Transcript",
            "transcriptEmpty": "Hier verschijnen afgeronde reacties.",
            "notes": "Notities",
            "characterMemoryTab": "Wat het karakter zich herinnert",
            "openAriaLabel": "Paneel «{panel}» openen",
            "closeAriaLabel": "Paneel «{panel}» sluiten"
        },
        "sound": {
            "label": "Geluid",
            "volumeLabel": "Volume",
            "speakerLabel": "Luidspreker"
        },
        "end": {
            "button": "Beëindigen",
            "confirmTitle": "Gesprek beëindigen?",
            "elapsed": "{elapsed} verstreken van {total}.",
            "partialEvaluationNotice": "Het gesprek wordt beoordeeld op basis van wat u heeft behandeld.",
            "continue": "Doorgaan",
            "notSent": "Het gesprek eindigt op tijd: de server reageerde niet op het verzoek om te beëindigen."
        },
        "wait": {
            "title": "Het gesprek wordt voorbereid",
            "hint": "Dit duurt meestal 1–3 minuten. Sluit de pagina niet — we beginnen automatisch.",
            "nextTry": "Volgende poging over {time}",
            "trying": "Proberen te starten…",
            "retrying": "Nog niet gelukt. Opnieuw proberen over {time}",
            "cancel": "Annuleren",
            "failed": {
                "title": "Het gesprek kon niet worden gestart",
                "text": "Er zijn momenteel geen vrije plekken. Uw microfoon- en camera-instellingen zijn opgeslagen — probeer het over een paar minuten opnieuw.",
                "retry": "Opnieuw proberen"
            }
        },
        "connection": {
            "reconnecting": "Verbinding verbroken, opnieuw verbinden…",
            "restored": "Verbinding hersteld",
            "failed": "Verbinding kon niet worden hersteld",
            "retry": "Opnieuw proberen"
        },
        "hotkeys": {
            "title": "Sneltoetsen",
            "showHintAriaLabel": "Sneltoetsen tonen",
            "micToggle": "Microfoon aan/uit",
            "scenarioPanel": "Scenario: paneel openen en sluiten",
            "transcriptPanel": "Transcript",
            "notesPanel": "Notities",
            "captionsToggle": "Ondertiteling aan/uit",
            "closeTopLayer": "Paneel, popover of dialoog sluiten",
            "endConfirm": "Beëindigen — opent de bevestiging",
            "showHint": "Deze hint tonen"
        },
        "intro": {
            "candidate": {
                "greeting": "Hallo, {name}!",
                "leadWithVacancy": "{organization} nodigt u uit voor een interview met een virtuele gesprekspartner voor de functie «{vacancy}».",
                "duration": "Het interview duurt ongeveer {minutes} min.",
                "requirementsTitle": "Wat u nodig heeft",
                "requirementMic": "Een werkende microfoon, bij voorkeur een headset",
                "requirementCameraRequired": "Camera ingeschakeld: voor dit interview is dat verplicht",
                "requirementCameraOptional": "Een camera is niet verplicht, maar het gesprek verloopt natuurlijker als u hem aanzet",
                "requirementBrowser": "Een computer met een actuele versie van Chrome, Edge of Safari",
                "requirementNetwork": "Een stabiele internetverbinding en een rustige plek waar u niet gestoord wordt",
                "consentTextLabel": "Toestemmingstekst",
                "consentAccept": "Ik heb de tekst gelezen en geef toestemming voor de verwerking van mijn persoonsgegevens",
                "next": "Volgende"
            },
            "launch": {
                "title": "Oefengesprek",
                "lead": "U gaat zo praten met een virtuele gesprekspartner. Het gesprek wordt opgenomen en beoordeeld, en het resultaat gaat terug naar uw leerplatform.",
                "requirementsTitle": "Wat u nodig heeft",
                "requirementMic": "Een werkende microfoon, bij voorkeur een headset",
                "requirementCamera": "Een camera is niet verplicht, maar het gesprek verloopt natuurlijker als u hem aanzet",
                "requirementBrowser": "Een computer met een actuele versie van Chrome, Edge of Safari",
                "requirementNetwork": "Een stabiele internetverbinding en een rustige plek waar u niet gestoord wordt",
                "start": "Starten"
            }
        },
        "finished": {
            "candidate": {
                "title": "Bedankt!",
                "text": "Het interview is afgerond. Het resultaat gaat naar de recruiter — die neemt contact met u op. U kunt deze pagina nu sluiten."
            },
            "launch": {
                "title": "Bedankt!",
                "text": "Het gesprek is afgerond. Het resultaat verschijnt in uw leerplatform zodra het is beoordeeld. U kunt deze pagina nu sluiten."
            }
        },
        "closeDialogAriaLabel": "Dialoog sluiten"
    },
    "loopAvatars": {
        "title": "Loop-avatars",
        "upload": "Avatar uploaden",
        "newVersion": "Nieuwe versie",
        "newVersionHint": "“{name}”, huidige versie {version}. Het nieuwe pakket vervangt de video's in alle profielen met deze avatar.",
        "edit": "Avatar bewerken",
        "delete": "Avatar verwijderen",
        "empty": "Nog geen avatars",
        "headers": {
            "poster": "Poster",
            "name": "Naam",
            "gender": "Geslacht",
            "emotion": "Emotie",
            "visibility": "Zichtbaarheid",
            "version": "Versie",
            "profiles": "Profielen"
        },
        "gender": {
            "male": "Man",
            "female": "Vrouw"
        },
        "emotion": {
            "calm": "Kalm",
            "friendly": "Vriendelijk",
            "strict": "Streng"
        },
        "visibility": {
            "all": "Alle organisaties"
        },
        "fields": {
            "package": "Avatarpakket (.zip)"
        },
        "packageHint": "ZIP tot 100 MB met manifest.json, listen.mp4, talk.mp4, transitions.json en poster.jpg",
        "validation": {
            "packageTooLarge": "Het pakket mag niet groter zijn dan 100 MB"
        },
        "errors": {
            "requestFailed": "Verzoek mislukt. Probeer het opnieuw."
        },
        "confirmDetach": "Te ontkoppelen profielen: {count}. Ze schakelen over op de foto. Opslaan?",
        "confirmDelete": "Avatar “{name}” verwijderen?",
        "confirmDeleteWithProfiles": "Avatar “{name}” wordt gebruikt in profielen: {count}. Ze schakelen over op de foto. Verwijderen?"
    },
    "ttsVoices": {
        "title": "TTS-stemmen",
        "create": "Stem toevoegen",
        "edit": "Stem bewerken",
        "delete": "Stem verwijderen",
        "replaceSample": "Voorbeeld vervangen",
        "replaceSampleHint": "“{name}”, huidige voorbeeldversie {version}. Het nieuwe voorbeeld klinkt in alle profielen met deze stem.",
        "empty": "Nog geen stemmen",
        "play": "Voorbeeld afspelen",
        "stop": "Stoppen",
        "headers": {
            "name": "Naam",
            "provider": "Provider",
            "externalId": "Stem-ID",
            "gender": "Geslacht",
            "languages": "Talen",
            "visibility": "Zichtbaarheid",
            "sample": "Voorbeeld",
            "profiles": "Profielen"
        },
        "gender": {
            "male": "Man",
            "female": "Vrouw"
        },
        "visibility": {
            "all": "Alle organisaties"
        },
        "fields": {
            "sample": "Stemvoorbeeld",
            "speed": "Spreeksnelheid"
        },
        "sampleHint": "MP3, MP4 of M4A tot 5 MB",
        "sampleOptionalHint": "Optioneel — het voorbeeld wordt met de stem gegenereerd via de ID. MP3, MP4 of M4A tot 5 MB",
        "synthesizeSample": "Opnieuw genereren",
        "speedChangedHint": "Genereer het stemvoorbeeld opnieuw om de nieuwe snelheid te horen.",
        "speedSamplePromptTitle": "Snelheid gewijzigd",
        "speedSamplePrompt": "Het stemvoorbeeld klinkt nog steeds met de vorige snelheid. Opnieuw genereren? Het huidige voorbeeld wordt vervangen.",
        "saveAndSynthesize": "Opslaan en genereren",
        "saveOnly": "Alleen opslaan",
        "validation": {
            "sampleTooLarge": "Het voorbeeld mag niet groter zijn dan 5 MB"
        },
        "errors": {
            "requestFailed": "Verzoek mislukt. Probeer het opnieuw.",
            "sampleUnavailable": "Het voorbeeld kan niet worden afgespeeld"
        },
        "confirmDetach": "Te ontkoppelen profielen: {count}. Ze schakelen over op de connectorstem. Opslaan?",
        "confirmDelete": "Stem “{name}” verwijderen?",
        "confirmDeleteWithProfiles": "Stem “{name}” wordt gebruikt in profielen: {count}. Ze schakelen over op de connectorstem. Verwijderen?",
        "picker": {
            "none": "Standaardstem",
            "empty": "Geen catalogusstemmen voor dit geslacht",
            "loadError": "Stemmen konden niet worden geladen",
            "playSample": "Voorbeeld afspelen: {name}",
            "stopSample": "Voorbeeld stoppen: {name}",
            "sampleUnavailable": "Voorbeeld niet beschikbaar"
        }
    },
    "realtimeAvatars": {
        "title": "Live-avatars",
        "create": "Avatar toevoegen",
        "edit": "Avatar bewerken",
        "delete": "Avatar verwijderen",
        "preview": "Voorbeeld bekijken",
        "empty": "Nog geen avatars",
        "headers": {
            "poster": "Omslagbeeld",
            "name": "Naam",
            "provider": "Provider",
            "externalId": "Avatar-ID",
            "gender": "Geslacht",
            "visibility": "Zichtbaarheid",
            "profiles": "Profielen",
            "models": "Anam-modellen"
        },
        "gender": {
            "male": "Man",
            "female": "Vrouw"
        },
        "visibility": {
            "all": "Alle organisaties"
        },
        "nameHint": "Optioneel — de naam van Anam wordt gebruikt",
        "externalIdHint": "Als je de ID wijzigt, worden het omslagbeeld en het voorbeeld opnieuw van Anam geladen",
        "errors": {
            "requestFailed": "Verzoek mislukt. Probeer het opnieuw.",
            "previewUnavailable": "Het voorbeeld kan niet worden afgespeeld"
        },
        "confirmDetach": "Te ontkoppelen profielen: {count}. Ze schakelen over op de foto. Opslaan?",
        "confirmDelete": "Avatar “{name}” verwijderen?",
        "confirmDeleteWithProfiles": "Avatar “{name}” wordt gebruikt in profielen: {count}. Ze schakelen over op de foto. Verwijderen?",
        "picker": {
            "label": "Live-avatars",
            "empty": "Geen Live-avatars beschikbaar voor dit profiel",
            "emptyFiltered": "Geen Live-avatars van dit geslacht",
            "loadError": "Live-avatars konden niet worden geladen"
        }
    },
    "aiProfileAppearance": {
        "label": "Uiterlijk",
        "photo": "Eigen foto",
        "avatar": "Studio",
        "live": "Live",
        "mascot": "Mascotte",
        "filterGender": "Geslacht",
        "filterEmotion": "Emotie",
        "avatarsLabel": "Avatars",
        "avatarRequired": "Kies een avatar",
        "liveRequired": "Kies een Live-avatar",
        "livePlaceholder": "Je Live-avatar verschijnt hier",
        "empty": "Geen avatars beschikbaar voor dit profiel",
        "emptyFiltered": "Geen avatars voldoen aan de filters",
        "loadError": "Kan avatars niet laden",
        "playPreview": "Voorbeeld afspelen: {name}",
        "pausePreview": "Voorbeeld pauzeren: {name}"
    },
    "emailStopList": {
        "title": "E-mailblokkeerlijst",
        "description": "E-mails naar deze adressen en domeinen worden niet verzonden. Een domeinvermelding geldt voor alle adressen van dat domein, maar niet voor de subdomeinen.",
        "searchPlaceholder": "Zoeken op adres of domein",
        "allReasons": "Alle redenen",
        "add": "Toevoegen",
        "addTitle": "Een adres of domein blokkeren",
        "empty": "De blokkeerlijst is leeg",
        "editNote": "Notitie bewerken",
        "headers": {
            "type": "Type",
            "value": "Adres of domein",
            "reason": "Reden",
            "providerReply": "Antwoord van de mailservice",
            "note": "Notitie",
            "author": "Toegevoegd door",
            "createdAt": "Toegevoegd op",
            "blockedCount": "Tegengehouden e-mails",
            "lastBlockedAt": "Laatst tegengehouden"
        },
        "type": {
            "address": "Adres",
            "domain": "Domein"
        },
        "reason": {
            "manual": "Handmatig toegevoegd",
            "providerRejected": "Geweigerd door de mailservice"
        },
        "author": {
            "system": "Systeem"
        },
        "fields": {
            "value": "Adres of domein",
            "valueHint": "Voer een volledig adres of alleen een domein in. Een domein blokkeert al zijn adressen, maar niet de subdomeinen.",
            "note": "Notitie"
        },
        "errors": {
            "requestFailed": "Er is iets misgegaan. Probeer het opnieuw."
        },
        "unblock": {
            "action": "Deblokkeren",
            "confirm": "{value} deblokkeren?",
            "resultTitle": "Resultaat van deblokkeren",
            "result": {
                "removedEverywhere": "Gedeblokkeerd. De mailservice heeft dit adres niet in zijn blokkeerlijst, dus e-mails worden weer verzonden.",
                "removedLocally": "Domein gedeblokkeerd. Adressen van dit domein met een eigen vermelding blijven geblokkeerd.",
                "providerNotConfigured": "Alleen de vermelding van het platform is verwijderd: de verbinding met de mailservice is niet ingesteld, dus de blokkeerlijst daarvan is niet gecontroleerd.",
                "providerUnavailable": "De mailservice is niet beschikbaar, probeer het later opnieuw. Het adres blijft voorlopig geblokkeerd.",
                "stillListedAtProvider": "Het adres staat in de blokkeerlijst van de mailservice. Verwijder het in het paneel van de mailservice en klik daarna op “Opnieuw deblokkeren”. Als het adres niet in het paneel staat, staat het in de algemene blokkeerlijst van de service en kan het daar niet worden verwijderd."
            },
            "openPanel": "Het paneel van de mailservice openen",
            "panelPath": "Zo verwijdert u het: paneel van de mailservice → Products → Email Service → uw resource → tabblad Stop Lists.",
            "retry": "Opnieuw deblokkeren"
        },
        "suggestions": {
            "text": "Het domein {domain} heeft {count} geblokkeerde adressen. Het hele domein blokkeren?",
            "block": "Domein blokkeren",
            "confirm": "Het domein {domain} blokkeren? E-mails naar al zijn adressen worden dan niet meer verzonden. Subdomeinen worden niet geraakt, de vermeldingen voor afzonderlijke adressen blijven bestaan."
        },
        "check": {
            "title": "Een adres controleren",
            "hint": "Toont of e-mails naar het adres worden geblokkeerd door het platform of door de mailservice",
            "placeholder": "E-mailadres",
            "submit": "Controleren",
            "resultFor": "Resultaat voor {email}",
            "platform": "Blokkeerlijst van het platform",
            "platformListed": "Ja — vermelding “{value}”",
            "provider": "Blokkeerlijst van de mailservice",
            "listed": "Ja",
            "notListed": "Nee",
            "providerReasons": "Redenen van de mailservice:",
            "providerNotConfigured": "De verbinding met de mailservice is niet ingesteld",
            "providerUnavailable": "De mailservice is niet beschikbaar, probeer het later opnieuw"
        }
    }
}
